import DiPdfPreview from "pages/forms/generatePDF/DiPdfPreview";
import React, {  useRef, Suspense, useEffect, useState, useCallback,useMemo,} from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { es } from "date-fns/locale";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import "css/formDIFilterResponsive.css";
import TextField from "@mui/material/TextField";
import SendIcon from "@mui/icons-material/Send";
import "css/generalSettings.css";
import "css/customDialog.css";
import { CONFIRM_CODE, MAX_PDF, MAX_ZIP, ENDPOINT } from "constants/variables";
import { setFilters, resetFilters } from "reducers/filtersFormDISlice";
import { resetPagination } from "reducers/paginationFormDISlice";
import { setLoading, setReloadRefreshData } from "reducers/loadingSlice";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { LoadingNews } from "components/utils/LoadingNews";
import TableSortingFormDI from "pages/forms/filterFormDI/SortingTablesFormDI";
import FormDIPDF from "pages/forms/generatePDF/FormiPDF";
import FormDIPurchase from "pages/forms/filterFormDI/FormDIPurchaseView/FormDIPurchase";
import FormDIShared from "pages/forms/filterFormDI/FormDIShared";
import FormDIShipping from "pages/forms/filterFormDI/FormDIShippingView/FormDIShipping";
import exportFormDIToExcel from "pages/forms/filterFormDI/FormDIExportToExcel";

const initialFiltersFormDI = {
  idFrom: "",
  idTo: "",
  defaultStoreIdFrom: "",
  defaultStoreIdTo: "",
  useraccountIdFrom: "",
  useraccountIdTo: "",
  typesdiFromES: "",
  typesdiToES: "",
  typesdiFromEN: "",
  typesdiToEN: "",
  isFinished: false,
  isScanned: true,
  isPending: true,
  notIsScanned: true,
  preiddocSheetFrom: "",
  preiddocSheetTo: "",
  sufiddocSheetFrom: "",
  sufiddocSheetTo: "",
  numberDTFrom: "",
  numberDTTo: "",
  dateSheetFrom: null,
  dateSheetTo: null,
  rel_trans_store_idFrom: "",
  rel_trans_store_idTo: "",
  ori_tras_store_idFrom: "",
  ori_tras_store_idTo: "",
  vehicleFrom: "",
  vehicleTo: "",
  acceptFROM: "",
  acceptTO: "",
  numberPurchaseDeliveryFROM: "",
  numberPurchaseDeliveryTO: "",
};

const initialDefaultStoresToSelect = [
  { id: "", documentid: "", tradename: "", name: "" },
];

const initialStoresToSelect = [{ id: "", documentid: "", tradename: "" }];
const initialVehicleToSelect = [{ id: "", vehiclestore_licenseplate: "" }];
const initialUserAccountToSelect = [
  {
    id: "",
    username: "",
    firstName: "",
    lastName1: "",
    lastName2: "",
    email: "",
    aliasuser: "",
  },
];

const textAccepted = [
  { id: 1, name: "Text_NOT_REPORTING" },
  { id: 2, name: "Operadora" },
  { id: 3, name: "Text_FORM_IsNotAccept" },
  { id:4, name : "Text_FORM_IsAnnulled"}
];

const initialStateFormDI = [
  {
    id: 0,
    ownformdi_id: 0,
    defaultStore_id: 0,
    tradename: "",
    useraccount_id: 0,
    username: "",
    defaultformatnumber: 0,
    isPending: true,
    isFinished: false,
    isScanned: false,
    preiddoc_sheet: "",
    sufiddoc_sheet: "",
    number_dt: "",
    date_sheet: "",
    accept: "",

    opt_tras_store_id: 0,
    opt_tras_tradename: "",
    opt_tras_nima: "",

    ori_tras_store_id: 0,
    ori_tras_tradename: "",
    ori_tras_nima: "",
    ori_tras_postalcode: "",

    dest_tras_store_id: 0,
    dest_tras_tradename: "",
    dest_tras_nima: "",
    dest_tras_inscription: "",
    dest_tras_postalcode: "",

    rel_trans_store_id: 0,
    rel_trans_tradename: "",
    rel_trans_nima: "",
    rel_trans_licenseplate: "",

    codeler_code: "",
    codeler_namees: "",
    treatmenttypedestine_code: "",
    treatmenttypedestine_namees: "",
    processtypedestine_code: "",
    processtypedestine_namees: "",
    amount: 0,
    hasbeenfinishedscanned: false,
    hasbeenshared: false,
    purchaseDeliveryAssociates: "",
    hasbeensentesir: false,
    statussentesir: 0,
    reasonrefund: "",
    end_date_sheet: "",
    widevalidity: false,
  },
];

const upper = (v) => String(v ?? "").toUpperCase();
const isBlank = (v) => String(v ?? "").trim() === "";
const stripVehicle = (v) => upper(v).replace(/[.-]/g, "");
const stripIdLike = (v) => String(v ?? "").replace(/[.-]/g, "").trim();

const buildMenuPermissions = (roles) => {
  const list = roles?.[0]?.listmenus ?? [];
  const has = (name) => list.some((m) => m.name === name);
  return {
    canFormEnded: has("SubMenu_Form_Ended"),
    canFormEdit: has("SubMenu_Form_Edit"),
    canFormPrint: has("SubMenu_Form_Print"),
    canFormDelete: has("SubMenu_Form_Delete"),
    canExcel: has("SubMenu_Form_Handle_Excel"),
    canFormEmail: has("SubMenu_Form_Handle_EMAILs"),
    canFormIncidentEmail: has("SubMenu_Form_Handle_INCIDENTEMAILs"),
    canFormESIR: has("SubMenu_Form_Handle_ESIR"),
    canFormESIRPartB: has("SubMenu_Form_Handle_ESIR_PART_B"),
    canFormESIRDelete: has("SubMenu_Form_Handle_ESIR_DELETE"),
    canShipping: has("SubMenu_Form_Handle_SHIPPING"),
    canSettingsPurchases: has("SubMenu_Settings_Purchases"),
    canStoreMaster: has("SubMenu_Settings_Forms_Store_Master"),
    canUserMaster: has("SubMenu_Settings_Forms_User_Master"),
    canDriverMaster: has("SubMenu_Settings_Forms_Person"),
    canViewOriTrasTradename: has("View_Form_Filter_OriTras_Tradename"),
    canViewOriTrasStreet: has("View_Form_Filter_OriTras_Street"),
    canViewDestTrasTradename: has("View_Form_Filter_DestTras_Tradename"),
    canViewDestTrasStreet: has("View_Form_Filter_DestTras_Street"),
    canViewCodeLERCode: has("View_Form_Filter_CodeLer_Code"),
    canViewCodeLERDescription: has("View_Form_Filter_CodeLer_Description"),
    canDecaHistory: has("SubMenu_Form_DECA_History"),
  };
};

const scrollToIndex = (containerSelector, index) => {
  const dropdown = document.querySelector(containerSelector);
  const item = dropdown?.children?.[index];
  if (item) {
    item.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }
};
 
const useDebouncedCallback = (cb, delay = 300) => {
  const cbRef = useRef(cb);
  const tRef = useRef(null);
  useEffect(() => {
    cbRef.current = cb;
  }, [cb]);
  useEffect(() => {
    return () => {
      if (tRef.current) clearTimeout(tRef.current);
    };
  }, []);
  return useCallback(
    (...args) => {
      if (tRef.current) clearTimeout(tRef.current);
      tRef.current = setTimeout(() => cbRef.current(...args), delay);
    },
    [delay]
  );
};

const useRangeAutocomplete = ({
  list,
  getLabel,
  getSecondaryLabel,
  fromValue,
  toValue,
  setFromValue,
  setToValue,
  allowToItem = () => true,
  normalizeExact = (v) => upper(v),
  normalizeInput = (v) => upper(v),
  dropdownSelector = ".dropdown-class",
}) => {
  const [filteredFrom, setFilteredFrom] = useState([]);
  const [hiFrom, setHiFrom] = useState(-1);
  const [filteredTo, setFilteredTo] = useState([]);
  const [hiTo, setHiTo] = useState(-1);
  const debouncedSearchFrom = useDebouncedCallback((searchValue) => {
    const q = upper(searchValue);
    if (isBlank(q)) {
      setFilteredFrom([]);
      setHiFrom(-1);
      return;
    }
    const filtered = (list ?? [])
      .filter((it) => it && getLabel(it))
      .filter((it) => {
        const a = upper(getLabel(it));
        const b = upper(getSecondaryLabel?.(it));
        return a.includes(q) || b.includes(q);
      })
      .slice(0, 20);
    setFilteredFrom(filtered);
    setHiFrom(filtered.length ? 0 : -1);
  }, 300);
  const debouncedSearchTo = useDebouncedCallback((searchValue) => {
    const q = upper(searchValue);
    if (isBlank(q)) {
      setFilteredTo([]);
      setHiTo(-1);
      return;
    }
    const filtered = (list ?? [])
      .filter((it) => allowToItem(it))
      .filter((it) => it && getLabel(it))
      .filter((it) => {
        const a = upper(getLabel(it));
        const b = upper(getSecondaryLabel?.(it));
        return a.includes(q) || b.includes(q);
      })
      .slice(0, 20);
    setFilteredTo(filtered);
    setHiTo(filtered.length ? 0 : -1);
  }, 300);
  const selectFrom = useCallback(
    (item) => {
      if (!item) return;
      const value = getLabel(item) || "";
      setFromValue(value);
      setToValue(value);   // ✅ siempre sincroniza
      setFilteredFrom([]);
      setHiFrom(-1);
    },
    [getLabel, setFromValue, setToValue]
  );

  const selectTo = useCallback(
    (item) => {
      if (!item) return;
      const value = getLabel(item) || "";
      setToValue(value);
      setFilteredTo([]);
      setHiTo(-1);
    },
    [getLabel, setToValue]
  );

  const keyDownFrom = useCallback(
    (event) => {
      if (event.key === "ArrowDown") {
        if (filteredFrom.length === 0 && isBlank(fromValue)) {
          setFilteredFrom(list ?? []);
          setHiFrom(0);
        } else {
          setHiFrom((prev) => {
            const next = prev < filteredFrom.length - 1 ? prev + 1 : prev;
            scrollToIndex(dropdownSelector, next);
            return next;
          });
        }
      } else if (event.key === "ArrowUp") {
        setHiFrom((prev) => {
          const next = prev > 0 ? prev - 1 : prev;
          scrollToIndex(dropdownSelector, next);
          return next;
        });
      } else if ((event.key === "Enter" || event.key === "Tab") && hiFrom >= 0) {
        if (hiFrom < filteredFrom.length) selectFrom(filteredFrom[hiFrom]);
      } else if (event.key === "Escape") {
        const isValid = (list ?? []).some((it) => {
          const label = getLabel(it);
          if (!label) return false;
          return normalizeExact(label) === normalizeInput(fromValue);
        });
        if (!isValid) setFromValue("");
        setFilteredFrom([]);
        setHiFrom(-1);
      }
    },
    [
      dropdownSelector,
      filteredFrom,
      fromValue,
      getLabel,
      hiFrom,
      list,
      normalizeExact,
      normalizeInput,
      selectFrom,
      setFromValue,
    ]
  );

  const keyDownTo = useCallback(
    (event) => {
      if (event.key === "ArrowDown") {
        if (filteredTo.length === 0 && isBlank(toValue)) {
          setFilteredTo((list ?? []).filter((it) => allowToItem(it)));
          setHiTo(0);
        } else {
          setHiTo((prev) => {
            const next = prev < filteredTo.length - 1 ? prev + 1 : prev;
            scrollToIndex(dropdownSelector, next);
            return next;
          });
        }
      } else if (event.key === "ArrowUp") {
        setHiTo((prev) => {
          const next = prev > 0 ? prev - 1 : prev;
          scrollToIndex(dropdownSelector, next);
          return next;
        });
      } else if ((event.key === "Enter" || event.key === "Tab") && hiTo >= 0) {
        if (hiTo < filteredTo.length) selectTo(filteredTo[hiTo]);
      } else if (event.key === "Escape") {
        const isValid = (list ?? [])
          .filter((it) => allowToItem(it))
          .some((it) => {
            const label = getLabel(it);
            if (!label) return false;
            return normalizeExact(label) === normalizeInput(toValue);
          });
        if (!isValid) setToValue("");
        setFilteredTo([]);
        setHiTo(-1);
      }
    },
    [
      dropdownSelector,
      filteredTo,
      getLabel,
      hiTo,
      list,
      normalizeExact,
      normalizeInput,
      selectTo,
      setToValue,
      toValue,
      allowToItem,
    ]
  );

  const clearAll = useCallback(() => {
    setFilteredFrom([]);
    setHiFrom(-1);
    setFilteredTo([]);
    setHiTo(-1);
  }, []);

  return {
    filteredFrom,
    hiFrom,
    filteredTo,
    hiTo,
    debouncedSearchFrom,
    debouncedSearchTo,
    selectFrom,
    selectTo,
    keyDownFrom,
    keyDownTo,
    clearAll,
    setFilteredFrom,
    setHiFrom,
    setFilteredTo,
    setHiTo,
  };
}; 

const FormsDIFilter = ({ showModalFormSettings, typeOfList }) => {
  const { t, i18n } = useTranslation(["listDataForms"]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.loginUser.token);
  const roles = useSelector((state) => state.loginUser.roles);
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);
  const defaultStore = useSelector((state) => state.loginUser.defaultStore);
  const LIMITPAGESIZE = useSelector(
    (state) => state.loginUser.defaultticketsformat.limitpagesize
  );
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code);
  const DELETE_CODE_FORMDI = useSelector(
    (state) => state.formatDIUser.delete_code_formdi
  );
  const filtersFormDIDetails = useSelector((state) => state.filtersFormDI);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const reloadRefreshData = useSelector(
    (state) => state.loading.reloadRefreshData ?? false
  );
  const menuPermissions = useMemo(
    () => buildMenuPermissions(roles),
    [roles]
  );
  const [dataFormDI, setDataFormDI] = useState(initialStateFormDI);
  const [formFormDI, setFormFormDI] = useState(initialStateFormDI[0]);
  const [filtersFormDI, setFiltersFormDI] = useState(filtersFormDIDetails);
  const [errorsFiltersFormDI, setErrorsFiltersFormDI] = useState({});
  const [numTotRegFilter, setNumTotRegFilter] = useState(0);
  const [numTotRegFormDI, setNumTotRegFormDI] = useState(0);
  const [inputTextFormDI, setInputTextFormDI] = useState("");
  const [openDeleteRowFormDI, setOpenDeleteRowFormDI] = useState(false);
  const [openEditRowFormDI, setOpenEditRowFormDI] = useState(false);
  const [openEditFilterFormDI, setOpenEditFilterFormDI] = useState(false);
  const [openErrorRowFormDI, setOpenErrorRowFormDI] = useState(false);
  const [openSharedRowFormDI, setOpenSharedRowFormDI] = useState(false);
  const [openCopyRowFormDI, setOpenCopyRowFormDI] = useState(false);
  const [openSendEmail, setOpenSendEmail] = useState(false);
  const [openViewPurchase, setOpenViewPurchase] = useState(false);
  const [openShippingRowFormDI, setOpenShippingRowFormDI] = useState(false);
  const [openViewShipping, setOpenViewShipping] = useState(false);
  const [rowEditFormDI, setRowEditFormDI] = useState(initialStateFormDI[0]);
  const [isLoadingErrorFormDI, setIsLoadingErrorFormDI] = useState(false);
  const [idCodeDelete, setIdCodeDelete] = useState(DELETE_CODE);
  const [idCodeReturn, setIdCodeReturn] = useState("");
  const [openReturnFormDI, setOpenReturnFormDI] = useState(false);
  const [numberCopy, setNumberCopy] = useState(1);
  const [viewPDF, setViewPDF] = useState(false);
  const [selectedPdfPreview, setSelectedPdfPreview] = useState(null);
  const [refeshData, setRefeshData] = useState(false);

  useEffect(() => {
    const refreshAfterDecaGeneration = () => setRefeshData(true);
    window.addEventListener('formdi-deca-generated', refreshAfterDecaGeneration);
    return () => window.removeEventListener(
      'formdi-deca-generated',
      refreshAfterDecaGeneration
    );
  }, []);

  const [activeOffsetFormDI, setActiveOffsetFormDI] = useState(false);
  const [currencyOffsetFormDI, setCurrencyOffsetFormDI] = useState(0);
  const [rangeOffsetFormDI, setRangeOffsetFormDI] = useState([{}]);
  const [storesToSelect, setStoresToSelect] = useState(
    initialDefaultStoresToSelect
  );
  const [userAccountsToSelect, setUserAccountsToSelect] = useState(
    initialUserAccountToSelect
  );
  const [tradenameToSelect, setTradenameToSelect] = useState(
    initialStoresToSelect
  );
  const [trasnporterToSelect, setTrasnporterToSelect] = useState(
    initialStoresToSelect
  );
  const [vehiclesToSelect, setVehiclesToSelect] = useState(
    initialVehicleToSelect
  );
 
  const resetAll = useCallback(() => {
    setDataFormDI(initialStateFormDI);
    setFormFormDI(initialStateFormDI[0]);
    setNumTotRegFilter(0);
    setNumTotRegFormDI(0);
    setErrorsFiltersFormDI({});
    setInputTextFormDI("");
    setOpenDeleteRowFormDI(false);
    setOpenErrorRowFormDI(false);
    setOpenEditRowFormDI(false);
    setOpenEditFilterFormDI(false);
    setRowEditFormDI(initialStateFormDI[0]);
    setIsLoadingErrorFormDI(false);
    setIdCodeDelete(DELETE_CODE);
    setViewPDF(false);
    setRefeshData(false);
    setOpenViewPurchase(false);
    setActiveOffsetFormDI(false);
    setCurrencyOffsetFormDI(0);
    setRangeOffsetFormDI([{}]);
    setStoresToSelect(initialDefaultStoresToSelect);
    setUserAccountsToSelect(initialUserAccountToSelect);
    setTrasnporterToSelect(initialStoresToSelect);
    setTradenameToSelect(initialStoresToSelect);
    setVehiclesToSelect(initialVehicleToSelect);
    setIdCodeReturn("");
    setOpenReturnFormDI(false);
    setNumberCopy(1);
    setOpenShippingRowFormDI(false);
    setOpenViewShipping(false);
    setOpenSharedRowFormDI(false);
    setOpenCopyRowFormDI(false);
    setOpenSendEmail(false);
    dispatch(setLoading(false));
    dispatch(setReloadRefreshData(false));
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersFormDI(initialFiltersFormDI);
  }, [DELETE_CODE, dispatch]);

  const closeModalFormDI = useCallback(() => {
    resetAll();
    navigate("/home");
  }, [navigate, resetAll]);
 
  const onGlobalKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape" && showModalFormSettings) {
        closeModalFormDI();
      }
    },
    [closeModalFormDI, showModalFormSettings]
  );

  useEffect(() => {
    document.addEventListener("keydown", onGlobalKeyDown);
    return () => document.removeEventListener("keydown", onGlobalKeyDown);
  }, [onGlobalKeyDown]);
 
  // Tradename ORI (From/To)
  const oriAuto = useRangeAutocomplete({
    list: tradenameToSelect,
    getLabel: (s) => s?.tradename ?? "",
    getSecondaryLabel: (s) => s?.documentid ?? "",
    fromValue: filtersFormDI.ori_tras_store_idFrom,
    toValue: filtersFormDI.ori_tras_store_idTo,
    setFromValue: (v) =>
      setFiltersFormDI((p) => ({
        ...p,
        ori_tras_store_idFrom: v, 
        ori_tras_store_idTo: p.ori_tras_store_idTo || v,
      })),
    setToValue: (v) =>
      setFiltersFormDI((p) => ({ ...p, ori_tras_store_idTo: v })),
    allowToItem: (s) =>
      (s?.tradename ?? "") >= (filtersFormDI.ori_tras_store_idFrom ?? ""),
  });

  // Transportista (From/To)
  const transAuto = useRangeAutocomplete({
    list: trasnporterToSelect,
    getLabel: (s) => s?.tradename ?? "",
    getSecondaryLabel: (s) => s?.documentid ?? "",
    fromValue: filtersFormDI.rel_trans_store_idFrom,
    toValue: filtersFormDI.rel_trans_store_idTo,
    setFromValue: (v) =>
      setFiltersFormDI((p) => ({
        ...p,
        rel_trans_store_idFrom: v,
        rel_trans_store_idTo: p.rel_trans_store_idTo || v,
      })),
    setToValue: (v) =>
      setFiltersFormDI((p) => ({ ...p, rel_trans_store_idTo: v })),
    allowToItem: (s) =>
      (s?.tradename ?? "") >= (filtersFormDI.rel_trans_store_idFrom ?? ""),
  });

  // Vehículos (From/To)
  const vehicleAuto = useRangeAutocomplete({
    list: vehiclesToSelect,
    getLabel: (v) => v?.vehiclestore_licenseplate ?? "",
    getSecondaryLabel: () => "",
    fromValue: filtersFormDI.vehicleFrom,
    toValue: filtersFormDI.vehicleTo,
    setFromValue: (v) =>
      setFiltersFormDI((p) => ({
        ...p,
        vehicleFrom: v,
        vehicleTo: p.vehicleTo || v,
      })),
    setToValue: (v) =>
      setFiltersFormDI((p) => ({ ...p, vehicleTo: v })),
    allowToItem: (v) =>
      (v?.vehiclestore_licenseplate ?? "") >= (filtersFormDI.vehicleFrom ?? ""),
    normalizeExact: (v) => stripVehicle(v),
    normalizeInput: (v) => stripVehicle(v),
  });

  const handleBlurAutocomplete = useCallback((event) => {
    if (!event?.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      oriAuto.clearAll();
      transAuto.clearAll();
      vehicleAuto.clearAll();
    }
  }, [oriAuto, transAuto, vehicleAuto]);
 
  const http = useMemo(() => helpHttp(), []);
  const getScope = useCallback(() => {
    // devuelve { storeId, userId } ya resueltos para endpoints genéricos
    const storeId = menuPermissions.canStoreMaster ? "-1" : defaultStore.id;
    const userId = menuPermissions.canUserMaster ? "-1" : useraccount_id;
    return { storeId, userId };
  }, [
    defaultStore.id,
    menuPermissions.canStoreMaster,
    menuPermissions.canUserMaster,
    useraccount_id,
  ]);

  const safeWarn = useCallback(
    (key) => dispatch(warningErrorAction(t(key))),
    [dispatch, t]
  );

  /* -------------------------- Carga listas (ORI/TRANS) -------------------------- */
  useEffect(() => {
    let alive = true;
    if (!showModalFormSettings) return;
    const { storeId, userId } = getScope();
    const isEnded = typeOfList === "1" ? false : true;
    const fetchTradename = async () => {
      try {
        const getData = await http.get7(
          ENDPOINT,
          `form/getlisttradenameformdi`,
          token,
          storeId,
          userId,
          isEnded
        );
        if (alive) dispatch(setLoading(false));
        if (!alive) return;
        if (getData?.err) safeWarn("Text_InvalidCredentials");
        else setTradenameToSelect(getData);
      } catch {
        if (alive) dispatch(setLoading(false));
        if (!alive) return;
        safeWarn("Text_IncorrectData");
      } 
    };
    const fetchTransporter = async () => {
      try {
        const getData = await http.get7(
          ENDPOINT,
          `form/getlisttransporterformdi`,
          token,
          storeId,
          userId,
          isEnded
        );
        if (alive) dispatch(setLoading(false));
        if (!alive) return;
        if (getData?.err) safeWarn("Text_InvalidCredentials");
        else setTrasnporterToSelect(getData);
      } catch {
        if (!alive) return;
        if (alive) dispatch(setLoading(false));
        safeWarn("Text_IncorrectData");
      } 
    };
    fetchTradename();
    fetchTransporter();

    return () => {
      alive = false;
    };
  }, [
    dispatch,
    getScope,
    http,
    safeWarn,
    showModalFormSettings,
    token,
    typeOfList,
  ]);

  /* -------------------------- Carga vehículos (depende TRANS) -------------------------- */
  useEffect(() => {
    let alive = true;
    if (!showModalFormSettings) return;
    const { storeId, userId } = getScope();
    const isEnded = typeOfList === "1" ? false : true;
    const relFrom = stripIdLike(filtersFormDI.rel_trans_store_idFrom);
    const relTo = stripIdLike(filtersFormDI.rel_trans_store_idTo);
    const fetchVehicles = async () => {
      try {
        const getData = await http.get10(
          ENDPOINT,
          `form/getlistvehiclesformdi`,
          token,
          storeId,
          userId,
          !isBlank(relFrom) ? relFrom : "-1",
          !isBlank(relTo) ? relTo : "-1",
          isEnded
        );
        if (alive) dispatch(setLoading(false));
        if (!alive) return;
        if (getData?.err) safeWarn("Text_InvalidCredentials");
        else setVehiclesToSelect(getData);
      } catch {
        if (alive) dispatch(setLoading(false));
        if (!alive) return;
        safeWarn("Text_IncorrectData");
      }
    };
    fetchVehicles();
    return () => {
      alive = false;
    };
  }, [
    dispatch,
    filtersFormDI.rel_trans_store_idFrom,
    filtersFormDI.rel_trans_store_idTo,
    getScope,
    http,
    safeWarn,
    showModalFormSettings,
    token,
    typeOfList,
  ]);

  /* ----------------------- Carga stores y userAccounts (masters) ----------------------- */
  useEffect(() => {
    let alive = true;
    if (!(showModalFormSettings || refeshData || reloadRefreshData)) return;
    const fetchStores = async () => {
      try {
        const getData = await http.get(
          ENDPOINT,
          `form/storesorderbytradename`,
          token
        );
        if (!alive) return;
        if (getData?.err) safeWarn("Text_InvalidCredentials");
        else setStoresToSelect(getData);
      } catch {
        if (!alive) return;
        safeWarn("Text_IncorrectData");
      }
    };
    const fetchUsers = async () => {
      try {
        const storeId = menuPermissions.canStoreMaster ? "-1" : defaultStore.id;
        const getData = await http.get2(
          ENDPOINT,
          `form/useraccountsorderbyusername/`,
          token,
          storeId
        );
        if (!alive) return;
        if (getData?.err) safeWarn("Text_InvalidCredentials");
        else setUserAccountsToSelect(getData);
      } catch {
        if (!alive) return;
        safeWarn("Text_IncorrectData");
      }
    };
    dispatch(setReloadRefreshData(false));
    setRefeshData(false);
    if (menuPermissions.canStoreMaster) fetchStores();
    if (menuPermissions.canUserMaster) fetchUsers();
    return () => {
      alive = false;
    };
  }, [
    dispatch,
    http,
    menuPermissions.canStoreMaster,
    menuPermissions.canUserMaster, 
    reloadRefreshData,
    safeWarn,
    showModalFormSettings,
    defaultStore.id,
    refeshData,
    token,
  ]);

  const validateFormFilterFormDI = useCallback(() => {
    const errors = {};
    const regexNumber = /^[0-9]+$/;
    const regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    const num = (v) => (isBlank(v) ? null : Number(v));
    // id from/to
    if (!isBlank(filtersFormDI.idFrom) && !regexNumber.test(filtersFormDI.idFrom))
      errors.idFrom = "Text_TextNoNumber";
    if (!isBlank(filtersFormDI.idTo) && !regexNumber.test(filtersFormDI.idTo))
      errors.idTo = "Text_TextNoNumber";
    if (!errors.idFrom && !errors.idTo) {
      const a = num(filtersFormDI.idFrom);
      const b = num(filtersFormDI.idTo);
      if (a !== null && b !== null && b < a) errors.idTo = "Text_TextGreater_Id";
    }
     if (
      !isBlank(filtersFormDI.numberPurchaseDeliveryFROM) &&
      !regexNumber.test(filtersFormDI.numberPurchaseDeliveryFROM)
    )
      errors.numberPurchaseDeliveryFROM = "Text_TextNoNumber";
    if (
      !isBlank(filtersFormDI.numberPurchaseDeliveryTO) &&
      !regexNumber.test(filtersFormDI.numberPurchaseDeliveryTO)
    )
      errors.numberPurchaseDeliveryTO = "Text_TextNoNumber";
    if (!errors.numberPurchaseDeliveryFROM && !errors.numberPurchaseDeliveryTO) {
      const a = num(filtersFormDI.numberPurchaseDeliveryFROM);
      const b = num(filtersFormDI.numberPurchaseDeliveryTO);
      if (a !== null && b !== null && b < a)
        errors.numberPurchaseDeliveryTO = "Text_TextGreater_Purchase";
    }
    // invalid chars
    if (regexInvalidCharacters.test(filtersFormDI.preiddocSheetFrom))
      errors.preiddocSheetFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filtersFormDI.preiddocSheetTo))
      errors.preiddocSheetTo = "Text_TextNoValid";
    if (
      !isBlank(filtersFormDI.sufiddocSheetFrom) &&
      !regexNumber.test(filtersFormDI.sufiddocSheetFrom)
    )
      errors.sufiddocSheetFrom = "Text_TextNoNumber";
    if (
      !isBlank(filtersFormDI.sufiddocSheetTo) &&
      !regexNumber.test(filtersFormDI.sufiddocSheetTo)
    )
      errors.sufiddocSheetTo = "Text_TextNoNumber";
    if (regexInvalidCharacters.test(filtersFormDI.numberDTFrom))
      errors.numberDTFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filtersFormDI.numberDTTo))
      errors.numberDTTo = "Text_TextNoValid";
    if (
      !isBlank(filtersFormDI.defaultStoreIdTo) &&
      filtersFormDI.defaultStoreIdTo < filtersFormDI.defaultStoreIdFrom
    )
      errors.defaultStoreIdTo = "Text_TextGreater_Store";
    if (
      !isBlank(filtersFormDI.useraccountIdTo) &&
      filtersFormDI.useraccountIdTo < filtersFormDI.useraccountIdFrom
    )
      errors.useraccountIdTo = "Text_TextGreater_UserAccount";
    if (
      !isBlank(filtersFormDI.typesdiToES) &&
      filtersFormDI.typesdiToES < filtersFormDI.typesdiFromEN
    )
      errors.typesdiToES = "Text_TextGreater_DefaultTypeDi";
    if (
      !isBlank(filtersFormDI.typesdiToEN) &&
      filtersFormDI.typesdiToEN < filtersFormDI.typesdiFromEN
    )
      errors.typesdiToEN = "Text_TextGreater_DefaultTypeDi";
    if (
      !isBlank(filtersFormDI.preiddocSheetTo) &&
      filtersFormDI.preiddocSheetTo < filtersFormDI.preiddocSheetFrom
    )
      errors.preiddocSheetTo = "Text_TextGreater_PreiddocSheet";
    if (
      !isBlank(filtersFormDI.sufiddocSheetTo) &&
      filtersFormDI.sufiddocSheetTo < filtersFormDI.sufiddocSheetFrom
    )
      errors.sufiddocSheetTo = "Text_TextGreater_SufiddocSheet";
    if (
      !isBlank(filtersFormDI.numberDTTo) &&
      filtersFormDI.numberDTTo < filtersFormDI.numberDTFrom
    )
      errors.numberDTTo = "Text_TextGreater_numberDTTo";
    if (regexInvalidCharacters.test(filtersFormDI.rel_trans_store_idFrom))
      errors.rel_trans_store_idFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filtersFormDI.rel_trans_store_idTo))
      errors.rel_trans_store_idTo = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filtersFormDI.ori_tras_store_idFrom))
      errors.ori_tras_store_idFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filtersFormDI.ori_tras_store_idTo))
      errors.ori_tras_store_idTo = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filtersFormDI.vehicleFrom))
      errors.vehicleFrom = "Text_TextNoValid";
    if (regexInvalidCharacters.test(filtersFormDI.vehicleTo))
      errors.vehicleTo = "Text_TextNoValid";
    return errors;
  }, [filtersFormDI]);

  const openEditFiltersFormDI = useCallback(() => {
    setOpenEditFilterFormDI((v) => !v);
  }, []);

  const handleSubmitFilterEditFormDI = useCallback(() => {
    const errs = validateFormFilterFormDI();
    setErrorsFiltersFormDI(errs);
    if (Object.keys(errs).length === 0) {
      dispatch(resetPagination());
      dispatch(setFilters(filtersFormDI));
      setOpenEditFilterFormDI(false);
    } else {
      dispatch(warningErrorAction(t("Text_Error_Filter")));
    }
  }, [dispatch, filtersFormDI, t, validateFormFilterFormDI]);

  const handleDeleteFiltersFormDI = useCallback(() => {
    setErrorsFiltersFormDI({});
    dispatch(resetPagination());
    dispatch(resetFilters());
    setFiltersFormDI(initialFiltersFormDI);
    setOpenEditFilterFormDI((v) => !v);
  }, [dispatch]);

  const handleCancelFiltersFormDI = useCallback(() => {
    setErrorsFiltersFormDI({});
    setOpenEditFilterFormDI((v) => !v);
  }, []);

  const handleChangeFilterEditFormDI = useCallback((e) => {
    const { name, value } = e.target;
    setFiltersFormDI((p) => ({ ...p, [name]: value }));
  }, []);

  const handleBlurFilterEditFormDI = useCallback(
    (e) => {
      handleChangeFilterEditFormDI(e);
      setErrorsFiltersFormDI(validateFormFilterFormDI());
    },
    [handleChangeFilterEditFormDI, validateFormFilterFormDI]
  );

  const handleChangeSelectDateSheetFrom = useCallback((event) => {
    setFiltersFormDI((p) => ({
      ...p,
      dateSheetFrom: event !== null ? new Date(event) : null,
      dateSheetTo: null,
    }));
  }, []);

  const handleChangeSelectDateSheetTo = useCallback((event) => {
    setFiltersFormDI((p) => ({
      ...p,
      dateSheetTo: event !== null ? new Date(event) : null,
    }));
  }, []);

  const handleBlurSelectDateSheetFrom = useCallback(
    (e) => {
      handleChangeSelectDateSheetFrom(e);
      setErrorsFiltersFormDI(validateFormFilterFormDI());
    },
    [handleChangeSelectDateSheetFrom, validateFormFilterFormDI]
  );

  const handleBlurSelectDateSheetTo = useCallback(
    (e) => {
      handleChangeSelectDateSheetTo(e);
      setErrorsFiltersFormDI(validateFormFilterFormDI());
    },
    [handleChangeSelectDateSheetTo, validateFormFilterFormDI]
  );

  const handleChangeSelectAccepted = useCallback((e) => {
    const { value } = e.target;
    setFiltersFormDI((p) => ({
      ...p,
      acceptFROM: value,
      acceptTO: value,
    }));
  }, []);

  const handleBlurSelectAccepted = useCallback(
    (e) => {
      handleChangeSelectAccepted(e);
      setErrorsFiltersFormDI(validateFormFilterFormDI());
    },
    [handleChangeSelectAccepted, validateFormFilterFormDI]
  );

  const handleChangeIsScannedFilter = useCallback(() => {
    setFiltersFormDI((p) => ({ ...p, isScanned: !p.isScanned }));
  }, []);

  const handleChangeIsNotScannedFilter = useCallback(() => {
    setFiltersFormDI((p) => ({ ...p, notIsScanned: !p.notIsScanned }));
  }, []);

  const handleCloseDataEditFormDI = useCallback(() => {
    setOpenEditRowFormDI(false);
    setOpenCopyRowFormDI(false);
    setNumberCopy(1);
    setRowEditFormDI((prev) => (openEditRowFormDI ? prev : initialStateFormDI[0]));
    dispatch(setLoading(false));
    setIsLoadingErrorFormDI(false);
    setRefeshData(false);
  }, [dispatch, openEditRowFormDI]);

  const toggleDrawerFilterEditFormDI = useCallback(
  (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    if (event.type === "keydown") {
      event.preventDefault();
      handleCloseDataEditFormDI();
    }
  },
  [handleCloseDataEditFormDI]
);
 
  const resolveInfoCountRequest = useCallback(async () => {
    // numTotRegFormDI
    if (!menuPermissions.canDriverMaster) {
      return typeOfList === "1"
        ? http.get8(
            ENDPOINT,
            `form/getinformationtableformdidriver`,
            token,
            useraccount_id,
            false
          )
        : http.get8(
            ENDPOINT,
            `form/getinformationtableformdidriver`,
            token,
            useraccount_id,
            true
          );
    }

    if (menuPermissions.canStoreMaster) {
      return typeOfList === "1"
        ? http.get2(ENDPOINT, `form/getinformationtableformdi/`, token, false)
        : http.get2(ENDPOINT, `form/getinformationtableformdi/`, token, true);
    }

    if (menuPermissions.canUserMaster) {
      return typeOfList === "1"
        ? http.get8(
            ENDPOINT,
            `form/getinformationtableformdiwithstore`,
            token,
            defaultStore.id,
            false
          )
        : http.get8(
            ENDPOINT,
            `form/getinformationtableformdiwithstore`,
            token,
            defaultStore.id,
            true
          );
    }
    return typeOfList === "1"
      ? http.get7(
          ENDPOINT,
          `form/getinformationtableformdiwithstoreanduseraccount`,
          token,
          defaultStore.id,
          useraccount_id,
          false
        )
      : http.get7(
          ENDPOINT,
          `form/getinformationtableformdiwithstoreanduseraccount`,
          token,
          defaultStore.id,
          useraccount_id,
          true
        );
  }, [
    defaultStore.id,
    http,
    menuPermissions.canDriverMaster,
    menuPermissions.canStoreMaster,
    menuPermissions.canUserMaster,
    token,
    typeOfList,
    useraccount_id,
  ]);

  const resolveCountFilterRequest = useCallback(async () => {
    if (!menuPermissions.canDriverMaster) {
      return http.post4(
        ENDPOINT,
        `form/getcountfilterformdidriver`,
        token,
        defaultStore.id,
        useraccount_id,
        typeOfList,
        filtersFormDIDetails
      );
    }

    if (menuPermissions.canStoreMaster) {
      return http.post4(
        ENDPOINT,
        `form/getcountfilterformdI`,
        token,
        "-1",
        "-1",
        typeOfList,
        filtersFormDIDetails
      );
    }

    if (menuPermissions.canUserMaster) {
      return http.post4(
        ENDPOINT,
        `form/getcountfilterformdI`,
        token,
        defaultStore.id,
        "-1",
        typeOfList,
        filtersFormDIDetails
      );
    }

    return http.post4(
      ENDPOINT,
      `form/getcountfilterformdI`,
      token,
      defaultStore.id,
      useraccount_id,
      filtersFormDIDetails
    );
  }, [
    defaultStore.id,
    filtersFormDIDetails,
    http,
    menuPermissions.canDriverMaster,
    menuPermissions.canStoreMaster,
    menuPermissions.canUserMaster,
    token,
    typeOfList,
    useraccount_id,
  ]);

  const resolveFormsRequest = useCallback(async () => {
    if (!menuPermissions.canDriverMaster) {
      return http.post6(
        ENDPOINT,
        `form/getformsdiddriver`,
        token,
        currencyOffsetFormDI,
        LIMITPAGESIZE,
        "-1",
        useraccount_id,
        typeOfList,
        filtersFormDIDetails
      );
    }

    if (menuPermissions.canStoreMaster) {
      return http.post6(
        ENDPOINT,
        `form/getformsdI`,
        token,
        currencyOffsetFormDI,
        LIMITPAGESIZE,
        "-1",
        "-1",
        typeOfList,
        filtersFormDIDetails
      );
    }
    if (menuPermissions.canUserMaster) {
      return http.post6(
        ENDPOINT,
        `form/getformsdI`,
        token,
        currencyOffsetFormDI,
        LIMITPAGESIZE,
        defaultStore.id,
        "-1",
        typeOfList,
        filtersFormDIDetails
      );
    }
    return http.post6(
      ENDPOINT,
      `form/getformsdI`,
      token,
      currencyOffsetFormDI,
      LIMITPAGESIZE,
      defaultStore.id,
      useraccount_id,
      typeOfList,
      filtersFormDIDetails
    );
  }, [
    LIMITPAGESIZE,
    currencyOffsetFormDI,
    defaultStore.id,
    filtersFormDIDetails,
    http,
    menuPermissions.canDriverMaster,
    menuPermissions.canStoreMaster,
    menuPermissions.canUserMaster,
    token,
    typeOfList,
    useraccount_id,
  ]);

  useEffect(() => {
    let alive = true;
    if (openSendEmail) {
      dispatch(setLoading(true));
      return () => {
        alive = false;
      };
    }
    if (!(showModalFormSettings || refeshData)) return;
    const run = async () => {
      try {
        const [info, count, forms] = await Promise.all([
          resolveInfoCountRequest(),
          resolveCountFilterRequest(),
          (async () => {
            dispatch(setLoading(true));
            return resolveFormsRequest();
          })(),
        ]);
        dispatch(setLoading(false));
        setRefeshData(false);
        if (!alive) return;
        const hasLoadFailed = (x) => x?.message === "Load failed";
        const isErr = (x) => x?.err || hasLoadFailed(x);
        if (isErr(info) || isErr(count)) {
          setDataFormDI(initialStateFormDI);
          if (hasLoadFailed(info) || hasLoadFailed(count)) {
            dispatch(warningErrorAction(t("Text_ConnectionFailied")));
          } else {
            dispatch(warningErrorAction(t("Text_InvalidCredentials")));
          }
          return;
        }
        setNumTotRegFormDI(info);
        setNumTotRegFilter(count);
        if (forms?.err) {
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        } else {
          setDataFormDI(forms);
        }
      } catch {
        dispatch(setLoading(false));
        setRefeshData(false);
        if (!alive) return;
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }   
    };
    run();
    return () => {
      alive = false;
    };
  }, [
    dispatch,
    openSendEmail,
    refeshData,
    resolveCountFilterRequest,
    resolveFormsRequest,
    resolveInfoCountRequest,
    showModalFormSettings,
    t,
  ]);

  useEffect(() => {
    if (numTotRegFormDI > Number(LIMITPAGESIZE)) {
      setActiveOffsetFormDI(true);
      const newRange = [
        {
          value: 0,
          label: ` 1 - ${Number(LIMITPAGESIZE).toLocaleString("de-DE")}`,
        },
      ];
      for (
        let i = Number(LIMITPAGESIZE);
        i < numTotRegFormDI;
        i += Number(LIMITPAGESIZE)
      ) {
        newRange.push({
          value: i,
          label: ` ${(i + 1).toLocaleString("de-DE")} - ${(
            i + Number(LIMITPAGESIZE)
          ).toLocaleString("de-DE")}`,
        });
      }
      setRangeOffsetFormDI(newRange);
    } else {
      setCurrencyOffsetFormDI(0);
      setActiveOffsetFormDI(false);
      setRangeOffsetFormDI([{}]);
    }
  }, [LIMITPAGESIZE, numTotRegFormDI]);

  useEffect(() => {
    if (!showModalFormSettings) {
      setFormFormDI(initialStateFormDI[0]);
      return;
    }
    const r = rowEditFormDI ?? initialStateFormDI[0];
    setFormFormDI((p) => ({
      ...p,
      ...Object.keys(initialStateFormDI[0]).reduce((acc, k) => {
        acc[k] = r[k] ?? initialStateFormDI[0][k];
        return acc;
      }, {}),
    }));
  }, [rowEditFormDI, showModalFormSettings]);

  const filteredDataFormDI = useMemo(() => {
    return (dataFormDI ?? []).filter((el) => {
      if (!inputTextFormDI) return true;
      const dataTranslate =
        String(el.id || "") +
        String(el.preiddoc_sheet || "") +
        String(el.sufiddoc_sheet || "") +
        (menuPermissions.canViewOriTrasTradename
          ? String(el.ori_tras_tradename || "")
          : "") +
        (menuPermissions.canViewDestTrasTradename
          ? String(el.dest_tras_tradename || "")
          : "") +
        String(el.rel_trans_tradename || "") +
        String(el.rel_trans_licenseplate || "");
      return dataTranslate.toLowerCase().includes(inputTextFormDI.toLowerCase());
    });
  }, [
    dataFormDI,
    inputTextFormDI,
    menuPermissions.canViewDestTrasTradename,
    menuPermissions.canViewOriTrasTradename,
  ]);

  const inputHandlerFormDI = useCallback((e) => {
    setInputTextFormDI(e.target.value.toLowerCase());
  }, []);

  const handleChangeDeleteRowFormDI = useCallback((e) => {
    setIdCodeDelete(e.target.value);
  }, []);

  const handleChangeCopyFormDI = useCallback((e) => {
    const v = parseInt(e.target.value, 10);
    if (v >= 1) setNumberCopy(v);
  }, []);

  const handleChangeEnableReturnFormDI = useCallback((e) => {
    setIdCodeReturn(e.target.value);
  }, []);

  const handleCancelReturnFormDI = useCallback(() => {
    setIdCodeReturn("");
    setOpenReturnFormDI(false);
  }, []);

  const handleCancelShippingFormDI = useCallback(() => {
    setIdCodeReturn("");
    setOpenShippingRowFormDI(false);
  }, []);

  const handleCancelDeleteRowFormDI = useCallback(() => {
    setRowEditFormDI(initialStateFormDI[0]);
    setIsLoadingErrorFormDI(false);
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRowFormDI(false);
  }, [DELETE_CODE]);

  const handleCancelErrorRowFORMDI = useCallback(() => {
    setRowEditFormDI(initialStateFormDI[0]);
    setIsLoadingErrorFormDI(false);
    setOpenErrorRowFormDI(false);
  }, []);

  const handleCancelCopyFormDI = useCallback(() => {
    setRowEditFormDI(initialStateFormDI[0]);
    setIsLoadingErrorFormDI(false);
    setNumberCopy(1);
    setOpenCopyRowFormDI(false);
  }, []);

  const openModalReturn = useCallback(() => {
    setOpenReturnFormDI(true);
  }, []);

  const isSingleFormDISelection = dataFormDI.filter((item) =>
    typeOfList === "1" ? item.isFinished === true : item.isPending === true
  ).length === 1;

  const handleFinishSelectedFormDI = useCallback(
    (e) => {
      if (!isSingleFormDISelection && idCodeReturn !== CONFIRM_CODE) {
        dispatch(warningErrorAction(t("Text_InvalidCodeConfirm")));
        return;
      }
      if (e?.key === "Escape") return;
      const selected = dataFormDI.filter((item) =>
        typeOfList === "1" ? item.isFinished === true : item.isPending === true
      );
      const payload = selected.map((item) => ({
        id: item.id,
        defaultStore_id: item.defaultStore_id,
        useraccount_id: item.useraccount_id,
        defaultformatnumber: item.defaultformatnumber,
        isScanned: item.isScanned,
        isFinished: typeOfList === "1",
        isPending: typeOfList !== "1",
        widevalidity: item.widevalidity,
      }));
      let alive = true;
      const run = async () => {
        dispatch(setLoading(true));
        try {
          const getData =
            typeOfList === "1"
              ? await http.put(ENDPOINT, `form/finishformdi`, token, payload)
              : await http.put(ENDPOINT, `form/returnformdi`, token, payload);
          if (alive) dispatch(setLoading(false));
          if (!alive) return;
          if (getData?.status === "OK") {
            dispatch(
              successErrorAction(typeOfList === "1" ? t("Text_Finished") : t("Text_Pending"))
            );
            handleCloseDataEditFormDI();
            setRefeshData(true);
          } else {
            dispatch(warningErrorAction(t(getData?.cause || "Text_IncorrectData")));
          }
        } catch {
          if (alive) dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        } 
      };
      run();
      setOpenDeleteRowFormDI(false);
      setIsLoadingErrorFormDI(false);
      setIdCodeReturn("");
      setOpenReturnFormDI(false);
      handleCloseDataEditFormDI();

      return () => {
        alive = false;
      };
    },
    [
      dataFormDI,
      isSingleFormDISelection,
      dispatch,
      handleCloseDataEditFormDI,
      http,
      idCodeReturn,
      t,
      token,
      typeOfList,
    ]
  );
 
  const handleCreateShipping = useCallback(
    (e) => {
      if (e?.key === "Escape") return;
      let alive = true;
      const run = async () => {
        dispatch(setLoading(true));
        try {
          const getData = await http.post(
            ENDPOINT,
            `form/createshippingformd`,
            token,
            rowEditFormDI
          );
          if (alive) dispatch(setLoading(false));
          if (!alive) return;
          if (getData?.status === "OK") {
            dispatch(successErrorAction(t("Text_Pending_CREATE_SHIPPING")));
            handleCloseDataEditFormDI();
            setRefeshData(true);
          } else {
            dispatch(warningErrorAction(t(getData?.cause || "Text_IncorrectData")));
          }
        } catch {
          if (alive) dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }  
      };
      run();
      setOpenShippingRowFormDI(false);
      setIsLoadingErrorFormDI(false);
      setIdCodeReturn("");
      handleCloseDataEditFormDI();
      return () => {
        alive = false;
      };
    },
    [dispatch, handleCloseDataEditFormDI, http, rowEditFormDI, t, token]
  );
 
  const handleCloseDeleteRowFormDI = useCallback(
    (e) => {
      if (idCodeDelete !== DELETE_CODE_FORMDI) {
        dispatch(warningErrorAction(t("Text_InvalidCode")));
        return;
      }
      if (e?.key === "Escape") return;
      if (rowEditFormDI.id === "") {
        dispatch(warningErrorAction(t("Text_InvalidId")));
        return;
      }
      let alive = true;
      const run = async () => {
        dispatch(setLoading(true));
        try {
          const getData = await http.del(
            ENDPOINT,
            `form/deleteformdi`,
            token,
            rowEditFormDI
          );
          if (alive) dispatch(setLoading(false));
          if (!alive) return;
          if (getData?.status === "OK") {
            dispatch(successErrorAction(t("Text_ValidCode")));
            dispatch(successErrorAction(t("Text_DeleteField")));
            setRefeshData(true);
            handleCloseDataEditFormDI();
          } else {
            dispatch(warningErrorAction(t(getData?.cause || "Text_IncorrectData")));
          }
        } catch {
          if (alive) dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }  
      };
      run();
      setIdCodeDelete(DELETE_CODE);
      setOpenDeleteRowFormDI(false);
      setIsLoadingErrorFormDI(false);
      handleCloseDataEditFormDI();
      return () => {
        alive = false;
      };
    },
    [
      DELETE_CODE,
      DELETE_CODE_FORMDI, 
      dispatch,
      handleCloseDataEditFormDI,
      http,
      idCodeDelete,
      rowEditFormDI,
      t,
      token,
    ]
  );
 
  const handleCloseCopyRowFormDI = useCallback(
    (e) => {
      if (e?.key === "Escape") return;
      if (rowEditFormDI.id === "") {
        dispatch(warningErrorAction(t("Text_InvalidId")));
        return;
      }
      let alive = true;
      const run = async () => {
        dispatch(setLoading(true));
        try {
          const getData = await http.post2(
            ENDPOINT,
            `form/cloneformdi`,
            token,
            numberCopy,
            rowEditFormDI
          );
          if (alive) dispatch(setLoading(false));
          if (!alive) return;
          if (getData?.status === "OK") {
            dispatch(successErrorAction(t("Text_SaveData")));
            setRefeshData(true);
            handleCloseDataEditFormDI();
          } else {
            dispatch(warningErrorAction(t(getData?.cause || "Text_IncorrectData")));
          }
        } catch {
          if (alive) dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        } 
      };
      run();
      setIdCodeDelete(DELETE_CODE);
      setOpenDeleteRowFormDI(false);
      setIsLoadingErrorFormDI(false);
      handleCloseDataEditFormDI();
      return () => {
        alive = false;
      };
    },
    [
      DELETE_CODE,
      dispatch,
      handleCloseDataEditFormDI,
      http,
      numberCopy,
      rowEditFormDI,
      t,
      token,
    ]
  );
 
  const handleSendEmailList = useCallback(
    (e) => {
      if (e?.key === "Escape") return;
      const selected =
        typeOfList === "1"
          ? dataFormDI.filter((i) => i.isFinished === true)
          : dataFormDI.filter((i) => i.isPending === true);

      if (selected.length === 0) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_NoSelection")));
        return;
      }
      if (selected.length > MAX_PDF) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_MaxSelectionExceeded")));
        return;
      }
      let alive = true;
      const run = async () => {
        dispatch(setLoading(true));
        setOpenSendEmail(true);
        try {
          const getData = await http.getfilesuploadwithheaders(
            ENDPOINT,
            `form/mergepdfs`,
            token,
            typeOfList,
            selected
          );
          if (!alive) return;
          if (getData?.status === "OK") {
            dispatch(setLoading(false));
            setOpenSendEmail(false);
            setRefeshData(true);
            handleCloseDataEditFormDI();
            const targetRoute =
            typeOfList === "1" ? "/formdisendemaillist" : "/formdisendemaillistended";
            navigate(targetRoute, { state: getData.response });
          } else {
            dispatch(setLoading(false));
            setOpenSendEmail(false);
            dispatch(warningErrorAction(t("Text_IncorrectData")));
          }
        } catch {
          if (!alive) return;
          dispatch(setLoading(false));
          setOpenSendEmail(false);
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }
      };
      run();
      return () => {
        alive = false;
      };
    },
    [ dataFormDI, dispatch, handleCloseDataEditFormDI, http, navigate, t, token, typeOfList]
  );

  const handleDownloadFormDIlList = useCallback(
    (e) => {
      if (e?.key === "Escape") return;
      const selected =
        typeOfList === "1"
          ? dataFormDI.filter((i) => i.isFinished === true)
          : dataFormDI.filter((i) => i.isPending === true);
      if (selected.length === 0) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_NoSelection")));
        return;
      }
      if (selected.length > 20) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(MAX_PDF + t("Text_MaxSelectionExceeded_PDF")));
        return;
      }
      let alive = true;
      const run = async () => {
        dispatch(setLoading(true));
        setOpenSendEmail(true);
        try {
          const getData = await http.getPdf(
            ENDPOINT,
            `form/mergelistpdfs`,
            token,
            typeOfList,
            selected
          );
          if (!alive) return;
          if (getData?.status === "OK") {
            dispatch(setLoading(false));
            setOpenSendEmail(false);
            setRefeshData(true);
            handleCloseDataEditFormDI();
            setSelectedPdfPreview(getData.blob);
          } else {
            dispatch(setLoading(false));
            setOpenSendEmail(false);
            dispatch(warningErrorAction(t("Text_IncorrectData")));
          }
        } catch {
          if (!alive) return;
          dispatch(setLoading(false));
          setOpenSendEmail(false);
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }
      };
      run();
      return () => {
        alive = false;
      };
    },
    [dataFormDI, dispatch, handleCloseDataEditFormDI, http, t, token, typeOfList]
  );

  const handleDownloadFormDIlListZip = useCallback(
    (e) => {
      if (e?.key === "Escape") return;
      const selected =
        typeOfList === "1"
          ? dataFormDI.filter((i) => i.isFinished === true)
          : dataFormDI.filter((i) => i.isPending === true);

      if (selected.length === 0) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_NoSelection")));
        return;
      }
      if (selected.length > MAX_ZIP) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(MAX_ZIP + t("Text_MaxSelectionExceeded_ZIP")));
        return;
      }
      let alive = true;
      const run = async () => {
        dispatch(setLoading(true));
        setOpenSendEmail(true);
        try {
          const getData = await http.getPdf(
            ENDPOINT,
            `form/ziplistpdfs`,
            token,
            typeOfList,
            selected
          );
          if (!alive) return;
          if (getData?.status === "OK") {
            dispatch(setLoading(false));
            setOpenSendEmail(false);
            setRefeshData(true);
            handleCloseDataEditFormDI();
            const blobUrl = URL.createObjectURL(getData.blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = "FormDIs.zip";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
          } else {
            dispatch(setLoading(false));
            setOpenSendEmail(false);
            dispatch(warningErrorAction(t("Text_IncorrectData")));
          }
        } catch {
          if (!alive) return;
          dispatch(setLoading(false));
          setOpenSendEmail(false);
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }
      };
      run();
      return () => {
        alive = false;
      };
    },
    [dataFormDI, dispatch, handleCloseDataEditFormDI, http, t, token, typeOfList]
  );

  const handleExport = useCallback(() => {
    if (!dataFormDI || dataFormDI.length === 0) return;
    const run = async () => {
      dispatch(setLoading(true));
      try {
        const getData = menuPermissions.canStoreMaster
          ? await http.post6(
              ENDPOINT,
              `form/getformsditoexcel`,
              token,
              currencyOffsetFormDI,
              LIMITPAGESIZE,
              "-1",
              "-1",
              typeOfList,
              filtersFormDIDetails
            )
          : menuPermissions.canUserMaster
          ? await http.post6(
              ENDPOINT,
              `form/getformsditoexcel`,
              token,
              currencyOffsetFormDI,
              LIMITPAGESIZE,
              "-1",
              useraccount_id,
              typeOfList,
              filtersFormDIDetails
            )
          : await http.post6(
              ENDPOINT,
              `form/getformsditoexcel`,
              token,
              defaultStore.id,
              useraccount_id,
              typeOfList,
              filtersFormDIDetails
            );

        if (getData?.err) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        } else if (Array.isArray(getData) && getData.length > 0) {
          dispatch(setLoading(false));
          exportFormDIToExcel(getData, "FORMULARIOS", t);
        }
      } catch {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      } 
    };

    run();
  }, [
    LIMITPAGESIZE,
    currencyOffsetFormDI,
    dataFormDI,
    defaultStore.id,
    dispatch,
    filtersFormDIDetails,
    http,
    menuPermissions.canStoreMaster,
    menuPermissions.canUserMaster,
    t,
    token,
    typeOfList,
    useraccount_id,
  ]);

  /* -------------------------------- Render -------------------------------- */

  return (
    <>
      {showModalFormSettings ? (
        <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingErrorFormDI ? (
                <i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>
              ) : isLoadingData ? (
                <CircularProgress color={openDeleteRowFormDI ? "warning" : "primary"} />
              ) : (
                <i className="fas fa-regular fa-clipboard text-warning"></i>
              )}{" "}
              {typeOfList === "1" ? t("Text_FormDI_Table") : t("Text_FormDI_ENDED")}
            </h1>

            {menuPermissions.canFormEnded ? (
              <div>
                <button
                  type="button"
                  className="formdi-pending-btn formdi-pending-btn--primary"
                  onClick={openModalReturn}
                >
                  {typeOfList === "1" ? t("Button_Finish") : t("Button_Pending")}
                </button>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <button
                  type="button"
                  className="formdi-pending-btn formdi-pending-btn--secondary"
                  onClick={closeModalFormDI}
                >
                  {t("Button_Back")}
                </button>
              </div>
            ) : (
              <div>
                <button
                  type="button"
                  className="formdi-pending-btn formdi-pending-btn--secondary"
                  onClick={closeModalFormDI}
                >
                  {t("Button_Back")}
                </button>
              </div>
            )}
          </div>

          <br />

          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputTextFormDI}
              inputProps={{ style: { fontSize: "18px" } }}
              InputLabelProps={{ style: { fontSize: "18px", background: "#f8f9fc" } }}
              placeholder={
                menuPermissions.canViewOriTrasTradename &&
                menuPermissions.canViewDestTrasTradename
                  ? t("Text_FormDI_Search_Ori_Dest")
                  : menuPermissions.canViewOriTrasTradename &&
                    !menuPermissions.canViewDestTrasTradename
                  ? t("Text_FormDI_Search_Ori")
                  : !menuPermissions.canViewOriTrasTradename &&
                    menuPermissions.canViewDestTrasTradename
                  ? t("Text_FormDI_Search_Dest")
                  : t("Text_FormDI_Search")
              }
              onChange={inputHandlerFormDI}
              fullWidth
              label={
                menuPermissions.canViewOriTrasTradename &&
                menuPermissions.canViewDestTrasTradename
                  ? t("Text_FormDI_Search_Ori_Dest")
                  : menuPermissions.canViewOriTrasTradename &&
                    !menuPermissions.canViewDestTrasTradename
                  ? t("Text_FormDI_Search_Ori")
                  : !menuPermissions.canViewOriTrasTradename &&
                    menuPermissions.canViewDestTrasTradename
                  ? t("Text_FormDI_Search_Dest")
                  : t("Text_FormDI_Search")
              }
            />
          </div>

          <br />

          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>

            <div className="formdi-pending-filters-row">
              <button type="button" className="formdi-pending-chip formdi-establish-filters-mobile" onClick={openEditFiltersFormDI}>
                {t("Button_Establish_Filters")}
              </button>
              <button
                type="button"
                className={`formdi-pending-chip ${
                  filtersFormDIDetails.idFrom !== "" || filtersFormDIDetails.idTo !== ""
                    ? "formdi-pending-chip--active"
                    : ""
                }`}
                onClick={openEditFiltersFormDI}
              >
                <span
                  className={`formdi-pending-dot ${
                    filtersFormDIDetails.idFrom !== "" || filtersFormDIDetails.idTo !== ""
                      ? "formdi-pending-dot--on"
                      : ""
                  }`}
                />
                {t("Text_Code")}
              </button>

              {menuPermissions.canDriverMaster && menuPermissions.canStoreMaster && (
                <button
                  type="button"
                  className={`formdi-pending-chip ${
                    filtersFormDIDetails.defaultStoreIdFrom !== "" ||
                    filtersFormDIDetails.defaultStoreIdTo !== ""
                      ? "formdi-pending-chip--active"
                      : ""
                  }`}
                  onClick={openEditFiltersFormDI}
                >
                  <span
                    className={`formdi-pending-dot ${
                      filtersFormDIDetails.defaultStoreIdFrom !== "" ||
                      filtersFormDIDetails.defaultStoreIdTo !== ""
                        ? "formdi-pending-dot--on"
                        : ""
                    }`}
                  />
                  {t("Text_Store")}
                </button>
              )}

              {menuPermissions.canDriverMaster &&
                menuPermissions.canStoreMaster &&
                menuPermissions.canUserMaster && (
                  <button
                    type="button"
                    className={`formdi-pending-chip ${
                      filtersFormDIDetails.useraccountIdFrom !== "" ||
                      filtersFormDIDetails.useraccountIdTo !== ""
                        ? "formdi-pending-chip--active"
                        : ""
                    }`}
                    onClick={openEditFiltersFormDI}
                  >
                    <span
                      className={`formdi-pending-dot ${
                        filtersFormDIDetails.useraccountIdFrom !== "" ||
                        filtersFormDIDetails.useraccountIdTo !== ""
                          ? "formdi-pending-dot--on"
                          : ""
                      }`}
                    />
                    {t("Text_UserAccount")}
                  </button>
                )}

              <button
                type="button"
                className={`formdi-pending-chip ${
                  filtersFormDIDetails.preiddocSheetFrom !== "" ||
                  filtersFormDIDetails.preiddocSheetTo !== ""
                    ? "formdi-pending-chip--active"
                    : ""
                }`}
                onClick={openEditFiltersFormDI}
              >
                <span
                  className={`formdi-pending-dot ${
                    filtersFormDIDetails.preiddocSheetFrom !== "" ||
                    filtersFormDIDetails.preiddocSheetTo !== ""
                      ? "formdi-pending-dot--on"
                      : ""
                  }`}
                />
                {t("Text_Prefix")}
              </button>

              <button
                type="button"
                className={`formdi-pending-chip ${
                  filtersFormDIDetails.sufiddocSheetFrom !== "" ||
                  filtersFormDIDetails.sufiddocSheetTo !== ""
                    ? "formdi-pending-chip--active"
                    : ""
                }`}
                onClick={openEditFiltersFormDI}
              >
                <span
                  className={`formdi-pending-dot ${
                    filtersFormDIDetails.sufiddocSheetFrom !== "" ||
                    filtersFormDIDetails.sufiddocSheetTo !== ""
                      ? "formdi-pending-dot--on"
                      : ""
                  }`}
                />
                {t("Text_Sufix")}
              </button>

              <button
                type="button"
                className={`formdi-pending-chip ${
                  filtersFormDIDetails.dateSheetFrom !== null ||
                  filtersFormDIDetails.dateSheetTo !== null
                    ? "formdi-pending-chip--active"
                    : ""
                }`}
                onClick={openEditFiltersFormDI}
              >
                <span
                  className={`formdi-pending-dot ${
                    filtersFormDIDetails.dateSheetFrom !== null ||
                    filtersFormDIDetails.dateSheetTo !== null
                      ? "formdi-pending-dot--on"
                      : ""
                  }`}
                />
                {t("Text_Date")}
              </button>

              <button
                type="button"
                className={`formdi-pending-chip ${
                  filtersFormDIDetails.isScanned ? "formdi-pending-chip--active" : ""
                }`}
                onClick={openEditFiltersFormDI}
              >
                <span
                  className={`formdi-pending-dot ${
                    filtersFormDIDetails.isScanned ? "formdi-pending-dot--on" : ""
                  }`}
                />
                {t("Text_IsScanned")}
              </button>

              <button
                type="button"
                className={`formdi-pending-chip ${
                  filtersFormDIDetails.notIsScanned ? "formdi-pending-chip--active" : ""
                }`}
                onClick={openEditFiltersFormDI}
              >
                <span
                  className={`formdi-pending-dot ${
                    filtersFormDIDetails.notIsScanned ? "formdi-pending-dot--on" : ""
                  }`}
                />
                {t("Text_IsNotScanned")}
              </button>

              <button
                type="button"
                className={`formdi-pending-chip ${
                  filtersFormDIDetails.numberDTFrom !== "" ||
                  filtersFormDIDetails.numberDTTo !== "" ||
                  filtersFormDIDetails.rel_trans_store_idFrom !== "" ||
                  filtersFormDIDetails.rel_trans_store_idTo !== "" ||
                  filtersFormDIDetails.ori_tras_store_idFrom !== "" ||
                  filtersFormDIDetails.ori_tras_store_idTo !== "" ||
                  filtersFormDIDetails.vehicleFrom !== "" ||
                  filtersFormDIDetails.vehicleTo !== "" ||
                  filtersFormDIDetails.acceptFROM !== "" ||
                  filtersFormDIDetails.acceptTO !== ""
                    ? "formdi-pending-chip--active"
                    : ""
                }`}
                onClick={openEditFiltersFormDI}
              >
                <span
                  className={`formdi-pending-dot ${
                    filtersFormDIDetails.numberDTFrom !== "" ||
                    filtersFormDIDetails.numberDTTo !== "" ||
                    filtersFormDIDetails.rel_trans_store_idFrom !== "" ||
                    filtersFormDIDetails.rel_trans_store_idTo !== "" ||
                    filtersFormDIDetails.ori_tras_store_idFrom !== "" ||
                    filtersFormDIDetails.ori_tras_store_idTo !== "" ||
                    filtersFormDIDetails.vehicleFrom !== "" ||
                    filtersFormDIDetails.vehicleTo !== "" ||
                    filtersFormDIDetails.acceptFROM !== "" ||
                    filtersFormDIDetails.acceptTO !== ""
                      ? "formdi-pending-dot--on"
                      : ""
                  }`}
                />
                {t("Text_Others_Filters")}
              </button>

              <button type="button" className="formdi-email-chip" onClick={handleSendEmailList}>
                <span className="formdi-action-label-full">{t("Button_SEND_EMAIL_LIST")}</span>
                <span className="formdi-action-label-mobile">{t("Button_SEND_EMAIL_LIST_MOBILE")}</span>
                <SendIcon sx={{ fontSize: 22, color: "white" }} />
              </button>
              <></>

              {menuPermissions.canFormPrint && (
                <button type="button" className="formdi-pdf-chip" onClick={handleDownloadFormDIlList}>
                  <span className="formdi-action-label-full">{t("Button_PDF_SELECT")}</span>
                <span className="formdi-action-label-mobile">{t("Button_PDF_SELECT_MOBILE")}</span>
                </button>
              )}

              {menuPermissions.canFormPrint && (
                <button type="button" className="formdi-zip-chip" onClick={handleDownloadFormDIlListZip}>
                  <span className="formdi-action-label-full">{t("Button_ZIP_SELECT")}</span>
                <span className="formdi-action-label-mobile">{t("Button_ZIP_SELECT_MOBILE")}</span>
                </button>
              )}

              {menuPermissions.canExcel && (
                <button type="button" className="formdi-excel-chip" onClick={handleExport}>
                  {t("Button_Excel")}
                </button>
              )}
            </div>
          </div>

          <br />

          {!isLoadingData ? (
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingFormDI
                    dataFormDI={filteredDataFormDI}
                    setDataFormDI={setDataFormDI}
                    setFormFormDI={setFormFormDI}
                    numTotRegFilter={numTotRegFilter}
                    titleTable={
                      typeOfList === "1"
                        ? t("Text_FormDI_Table_Pending")
                        : t("Text_FormDI_Table_ENDED")
                    }
                    setOpenDeleteRowFormDI={setOpenDeleteRowFormDI}
                    setOpenErrorRowFormDI={setOpenErrorRowFormDI}
                    setOpenSharedRowFormDI={setOpenSharedRowFormDI}
                    setOpenShippingRowFormDI={setOpenShippingRowFormDI}
                    setOpenViewShipping={setOpenViewShipping}
                    setOpenCopyRowFormDI={setOpenCopyRowFormDI}
                    setRowEditFormDI={setRowEditFormDI}
                    setOpenViewPurchase={setOpenViewPurchase}
                    showAssociatedPurchase={menuPermissions.canSettingsPurchases}
                    showFinishButtonFormDI={menuPermissions.canFormEnded}
                    showEditButtonFormDI={menuPermissions.canFormEdit}
                    showShippingButtonFormDI={menuPermissions.canShipping}
                    showPrintButtonFormDI={menuPermissions.canFormPrint}
                    showDeleteButtonFormDI={menuPermissions.canFormDelete}
                    showEmailButtonTickets={menuPermissions.canFormEmail}
                    showEmailIncidentButtonTickets={menuPermissions.canFormIncidentEmail}
                    showESIRButton={menuPermissions.canFormESIR}
                    showESIRDeleteButton={menuPermissions.canFormESIRDelete}
                    showDecaHistory={menuPermissions.canDecaHistory}
                    showStoreFormDI={menuPermissions.canStoreMaster}
                    showUserAccountFormDI={menuPermissions.canUserMaster}
                    numTotRegFormDI={numTotRegFormDI}
                    activeOffsetFormDI={activeOffsetFormDI}
                    rangeOffsetFormDI={rangeOffsetFormDI}
                    currencyOffsetFormDI={currencyOffsetFormDI}
                    setCurrencyOffsetFormDI={setCurrencyOffsetFormDI}
                    showOriTrasTradename={menuPermissions.canViewOriTrasTradename}
                    showOriTrasStreet={menuPermissions.canViewOriTrasStreet}
                    showDestTrasTradename={menuPermissions.canViewDestTrasTradename}
                    showDestTrasStreet={menuPermissions.canViewDestTrasStreet}
                    showCodeLERCode={menuPermissions.canViewCodeLERCode}
                    showCodeLERDescription={menuPermissions.canViewCodeLERDescription}
                    typeOfList={typeOfList}
                    setViewPDF={setViewPDF}
                    formFormDI={formFormDI}
                  />
                </div>
              </div>

              {openEditFilterFormDI && (
                <div>
                  <SwipeableDrawer
                    anchor="right"
                    PaperProps={{ className: "formdi-list-filter-panel" }}
                    open={true}
                    onClose={toggleDrawerFilterEditFormDI(false)}
                    onOpen={toggleDrawerFilterEditFormDI(true)}
                  >
                    <Container>
                      <Box sx={{ bgcolor: "#ffffff", minHeight: "100%", width: "100%" }}>
                        <div id="myDIV">
                          <h1 className="h1NewStyle px-4 mb-2">{t("Text_Filter")}</h1>
                        </div>
                        <hr className="sidebar-divider d-none d-md-block" />

                        <form className="createfiltformdi" onSubmit={handleCancelFiltersFormDI}>
                          <div className="form-floating mb-3 px-4 primary">
                            <div className="form-group">
                              <TextField
                                id="idFrom"
                                name="idFrom"
                                value={filtersFormDI.idFrom}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 15 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.idFrom != null
                                    ? t(errorsFiltersFormDI.idFrom)
                                    : t("Text_Filter_Code_From")
                                }
                                placeholder={t("PlaceHolder_Filter_Code_From")}
                                variant="outlined"
                                onBlur={handleBlurFilterEditFormDI}
                                onChange={handleChangeFilterEditFormDI}
                              />
                              
                              <TextField
                                id="idTo"
                                name="idTo"
                                value={filtersFormDI.idTo}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 15 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.idTo != null
                                    ? t(errorsFiltersFormDI.idTo)
                                    : t("Text_Filter_Code_To")
                                }
                                placeholder={t("PlaceHolder_Filter_Code_to")}
                                variant="outlined"
                                onBlur={handleBlurFilterEditFormDI}
                                onChange={handleChangeFilterEditFormDI}
                              />
                            </div>

                            {menuPermissions.canDriverMaster && menuPermissions.canStoreMaster && (
                              <>
                                <Suspense
                                  delayMs={500}
                                  fallback={<CircularProgress sx={{ color: "#f6c23e" }} />}
                                >
                                  <div className="form-group">
                                    <TextField
                                      id="defaultStoreIdFrom"
                                      name="defaultStoreIdFrom"
                                      value={filtersFormDI.defaultStoreIdFrom}
                                      inputProps={{ style: { width: 382, fontSize: "18px" }, maxLength: 100 }}
                                      InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                      label={
                                        errorsFiltersFormDI.defaultStoreIdFrom != null
                                          ? t(errorsFiltersFormDI.defaultStoreIdFrom)
                                          : t("Text_Filter_tradename_From")
                                      }
                                      placeholder={t("PlaceHolder_Filter_tradename_From")}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDI}
                                      select
                                      SelectProps={{ native: true }}
                                    >
                                      <option key={0} value="" />
                                      {storesToSelect.map((option) => (
                                        <option key={option.id} value={option.id}>
                                          {option.documentid + " - " + option.tradename}
                                        </option>
                                      ))}
                                    </TextField>

                                    

                                    <TextField
                                      id="defaultStoreIdTo"
                                      name="defaultStoreIdTo"
                                      value={filtersFormDI.defaultStoreIdTo}
                                      inputProps={{ style: { width: 382, fontSize: "18px" }, maxLength: 100 }}
                                      InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                      label={
                                        errorsFiltersFormDI.defaultStoreIdTo != null
                                          ? t(errorsFiltersFormDI.defaultStoreIdTo)
                                          : t("Text_Filter_tradename_To")
                                      }
                                      placeholder={t("PlaceHolder_Filter_tradename_to")}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDI}
                                      select
                                      SelectProps={{ native: true }}
                                    >
                                      <option key={0} value="" />
                                      {storesToSelect
                                        .filter((item) => item.id >= filtersFormDI.defaultStoreIdFrom)
                                        .map((option) => (
                                          <option key={option.id} value={option.id}>
                                            {option.documentid + " - " + option.tradename}
                                          </option>
                                        ))}
                                    </TextField>
                                  </div>
                                </Suspense>
                              </>
                            )}

                            {menuPermissions.canDriverMaster && menuPermissions.canUserMaster && (
                              <>
                                <Suspense
                                  delayMs={500}
                                  fallback={<CircularProgress sx={{ color: "#f6c23e" }} />}
                                >
                                  <div className="form-group">
                                    <TextField
                                      id="useraccountIdFrom"
                                      name="useraccountIdFrom"
                                      value={filtersFormDI.useraccountIdFrom}
                                      inputProps={{ style: { width: 382, fontSize: "18px" }, maxLength: 100 }}
                                      InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                      label={
                                        errorsFiltersFormDI.useraccountIdFrom != null
                                          ? t(errorsFiltersFormDI.useraccountIdFrom)
                                          : t("Text_Filter_UserAccount_From")
                                      }
                                      placeholder={t("PlaceHolder_UserAccount_From")}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDI}
                                      select
                                      SelectProps={{ native: true }}
                                    >
                                      <option key={0} value="" />
                                      {userAccountsToSelect.map((option) => (
                                        <option key={option.id} value={option.username}>
                                          {option.username + " - " + option.email}
                                        </option>
                                      ))}
                                    </TextField>

                                    

                                    <TextField
                                      id="useraccountIdTo"
                                      name="useraccountIdTo"
                                      value={filtersFormDI.useraccountIdTo}
                                      inputProps={{ style: { width: 382, fontSize: "18px" }, maxLength: 100 }}
                                      InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                      label={
                                        errorsFiltersFormDI.useraccountIdTo != null
                                          ? t(errorsFiltersFormDI.useraccountIdTo)
                                          : t("Text_Filter_UserAccount_To")
                                      }
                                      placeholder={t("PlaceHolder_UserAccount_To")}
                                      variant="outlined"
                                      onBlur={handleBlurFilterEditFormDI}
                                      onChange={handleChangeFilterEditFormDI}
                                      select
                                      SelectProps={{ native: true }}
                                    >
                                      <option key={0} value="" />
                                      {userAccountsToSelect
                                        .filter((item) => item.username >= filtersFormDI.useraccountIdFrom)
                                        .map((option) => (
                                          <option key={option.id} value={option.username}>
                                            {option.username + " - " + option.email}
                                          </option>
                                        ))}
                                    </TextField>
                                  </div>
                                </Suspense>
                              </>
                            )}

                            <div className="form-group">
                              <TextField
                                id="preiddocSheetFrom"
                                name="preiddocSheetFrom"
                                value={filtersFormDI.preiddocSheetFrom}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 20 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.preiddocSheetFrom != null
                                    ? t(errorsFiltersFormDI.preiddocSheetFrom)
                                    : t("Text_Filter_PreiddocSheet_From")
                                }
                                placeholder={t("PlaceHolder_Filter_PreiddocSheet_From")}
                                variant="outlined"
                                onBlur={handleBlurFilterEditFormDI}
                                onChange={handleChangeFilterEditFormDI}
                              />

                              

                              <TextField
                                id="preiddocSheetTo"
                                name="preiddocSheetTo"
                                value={filtersFormDI.preiddocSheetTo}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 20 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.preiddocSheetTo != null
                                    ? t(errorsFiltersFormDI.preiddocSheetTo)
                                    : t("Text_Filter_PreiddocSheet_To")
                                }
                                placeholder={t("PlaceHolder_Filter_PreiddocSheet_To")}
                                variant="outlined"
                                onBlur={handleBlurFilterEditFormDI}
                                onChange={handleChangeFilterEditFormDI}
                              />
                            </div>

                            <div className="form-group">
                              <TextField
                                id="sufiddocSheetFrom"
                                name="sufiddocSheetFrom"
                                value={filtersFormDI.sufiddocSheetFrom}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 15 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.sufiddocSheetFrom != null
                                    ? t(errorsFiltersFormDI.sufiddocSheetFrom)
                                    : t("Text_Filter_SufiddocSheet_From")
                                }
                                placeholder={t("PlaceHolder_Filter_SufiddocSheet_From")}
                                variant="outlined"
                                onBlur={handleBlurFilterEditFormDI}
                                onChange={handleChangeFilterEditFormDI}
                              />

                              

                              <TextField
                                id="sufiddocSheetTo"
                                name="sufiddocSheetTo"
                                value={filtersFormDI.sufiddocSheetTo}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 15 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.sufiddocSheetTo != null
                                    ? t(errorsFiltersFormDI.sufiddocSheetTo)
                                    : t("Text_Filter_SufiddocSheet_To")
                                }
                                placeholder={t("PlaceHolder_Filter_SufiddocSheet_To")}
                                variant="outlined"
                                onBlur={handleBlurFilterEditFormDI}
                                onChange={handleChangeFilterEditFormDI}
                              />
                            </div>

                            <div className="form-group">
                              <TextField
                                id="numberDTFrom"
                                name="numberDTFrom"
                                value={filtersFormDI.numberDTFrom}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 30 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.numberDTFrom != null
                                    ? t(errorsFiltersFormDI.numberDTFrom)
                                    : t("Text_Filter_NumberNT_From")
                                }
                                placeholder={t("PlaceHolder_Filter_NumberNT_From")}
                                variant="outlined"
                                onBlur={handleBlurFilterEditFormDI}
                                onChange={handleChangeFilterEditFormDI}
                              />

                              

                              <TextField
                                id="numberDTTo"
                                name="numberDTTo"
                                value={filtersFormDI.numberDTTo}
                                inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 30 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.numberDTTo != null
                                    ? t(errorsFiltersFormDI.numberDTTo)
                                    : t("Text_Filter_NumberNT_To")
                                }
                                placeholder={t("PlaceHolder_Filter_NumberNT_To")}
                                variant="outlined"
                                onBlur={handleBlurFilterEditFormDI}
                                onChange={handleChangeFilterEditFormDI}
                              />
                            </div>

                            <div className="form-group">
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                                adapterLocale={i18n.language === "es" ? es : undefined}
                              >
                                <DesktopDatePicker
                                  id="dateSheetFrom"
                                  name="dateSheetFrom"
                                  value={
                                    filtersFormDI.dateSheetFrom !== null
                                      ? new Date(filtersFormDI.dateSheetFrom)
                                      : null
                                  }
                                  format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
                                  label={
                                    errorsFiltersFormDI.dateSheetFrom != null
                                      ? t(errorsFiltersFormDI.dateSheetFrom)
                                      : t("PlaceHolder_Filter_DateSheet_From")
                                  }
                                  onBlur={handleBlurSelectDateSheetFrom}
                                  onChange={handleChangeSelectDateSheetFrom}
                                  slotProps={{
                                    textField: {
                                      placeholder:
                                        i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                      sx: { color: "#1565c0", maxLength: "100", width: 430, fontSize: "18px" },
                                      InputProps: { style: { fontSize: "18px" } },
                                      InputLabelProps: { style: { fontSize: "18px", background: "#FFFFFF" } },
                                    },
                                  }}
                                />
                              </LocalizationProvider>

                              

                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                                adapterLocale={i18n.language === "es" ? es : undefined}
                              >
                                <DesktopDatePicker
                                  id="dateSheetTo"
                                  name="dateSheetTo"
                                  minDate={
                                    filtersFormDI.dateSheetFrom !== null
                                      ? new Date(filtersFormDI.dateSheetFrom)
                                      : null
                                  }
                                  value={
                                    filtersFormDI.dateSheetTo !== null
                                      ? new Date(filtersFormDI.dateSheetTo)
                                      : null
                                  }
                                  format={i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy"}
                                  label={
                                    errorsFiltersFormDI.dateSheetTo != null
                                      ? t(errorsFiltersFormDI.dateSheetTo)
                                      : t("PlaceHolder_Filter_DateSheet_To")
                                  }
                                  onBlur={handleBlurSelectDateSheetTo}
                                  onChange={handleChangeSelectDateSheetTo}
                                  slotProps={{
                                    textField: {
                                      placeholder:
                                        i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                      sx: { color: "#1565c0", maxLength: "100", width: 430, fontSize: "18px" },
                                      InputProps: { style: { fontSize: "18px" } },
                                      InputLabelProps: { style: { fontSize: "18px", background: "#FFFFFF" } },
                                    },
                                  }}
                                />
                              </LocalizationProvider>
                            </div>

                            {/* ORI FROM / TO */}
                            <div className="form-group">
                              <span style={{ position: "relative" }}>
                                <TextField
                                  id="ori_tras_store_idFrom"
                                  name="ori_tras_store_idFrom"
                                  value={filtersFormDI.ori_tras_store_idFrom}
                                  onChange={(e) => {
                                    const v = upper(e.target.value);
                                    setFiltersFormDI((p) => ({
                                      ...p,
                                      ori_tras_store_idFrom: v,
                                      ori_tras_store_idTo: v,
                                    }));
                                    oriAuto.debouncedSearchFrom(v);
                                  }}
                                  onKeyDown={oriAuto.keyDownFrom}
                                  onBlur={(event) => {
                                    if (
                                      !event.relatedTarget ||
                                      !event.relatedTarget.closest(".dropdown-class")
                                    ) {
                                      handleBlurAutocomplete(event);
                                    }
                                  }}
                                  label={
                                    errorsFiltersFormDI.ori_tras_store_idFrom != null
                                      ? t(errorsFiltersFormDI.ori_tras_store_idFrom)
                                      : t("Text_Filter_TradeName_From")
                                  }
                                  placeholder={t("PlaceHolder_Filter_tradename_From")}
                                  inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                  variant="outlined"
                                />

                                {oriAuto.filteredFrom.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left: "0px",
                                      border: "2px solid #4e73df",
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: "18px",
                                      backgroundColor: "#f8f9fa",
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  >
                                    {oriAuto.filteredFrom.map((store, index) => (
                                      <MenuItem
                                        key={store.id}
                                        onClick={() => oriAuto.selectFrom(store)}
                                        style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: "18px",
                                          backgroundColor:
                                            index === oriAuto.hiFrom ? "#4e73df" : "transparent",
                                          color: index === oriAuto.hiFrom ? "white" : "black",
                                        }}
                                      >
                                        {store.documentid} - {store.tradename}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                              </span>

                              

                              <span style={{ position: "relative" }}>
                                <TextField
                                  id="ori_tras_store_idTo"
                                  name="ori_tras_store_idTo"
                                  value={filtersFormDI.ori_tras_store_idTo}
                                  onChange={(e) => {
                                    const v = upper(e.target.value);
                                    setFiltersFormDI((p) => ({ ...p, ori_tras_store_idTo: v }));
                                    oriAuto.debouncedSearchTo(v);
                                  }}
                                  onKeyDown={oriAuto.keyDownTo}
                                  onBlur={(event) => {
                                    if (
                                      !event.relatedTarget ||
                                      !event.relatedTarget.closest(".dropdown-class")
                                    ) {
                                      handleBlurAutocomplete(event);
                                    }
                                  }}
                                  label={
                                    errorsFiltersFormDI.ori_tras_store_idTo != null
                                      ? t(errorsFiltersFormDI.ori_tras_store_idTo)
                                      : t("Text_Filter_TradeName_To")
                                  }
                                  placeholder={t("PlaceHolder_Filter_tradename_to")}
                                  inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                  variant="outlined"
                                />

                                {oriAuto.filteredTo.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left: "0px",
                                      border: "2px solid #4e73df",
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: "18px",
                                      backgroundColor: "#f8f9fa",
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                  >
                                    {oriAuto.filteredTo.map((store, index) => (
                                      <MenuItem
                                        key={store.id}
                                        onClick={() => oriAuto.selectTo(store)}
                                        style={{
                                          cursor: "pointer",
                                          padding: "8px",
                                          borderBottom: "1px solid #eee",
                                          fontSize: "18px",
                                          backgroundColor:
                                            index === oriAuto.hiTo ? "#4e73df" : "transparent",
                                          color: index === oriAuto.hiTo ? "white" : "black",
                                        }}
                                      >
                                        {store.documentid} - {store.tradename}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                              </span>
                            </div>

                            {/* TRANS FROM / TO */}
                            {menuPermissions.canDriverMaster && (
                              <div className="form-group">
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="rel_trans_store_idFrom"
                                    name="rel_trans_store_idFrom"
                                    value={filtersFormDI.rel_trans_store_idFrom}
                                    onChange={(e) => {
                                      const v = upper(e.target.value);
                                      setFiltersFormDI((p) => ({
                                        ...p,
                                        rel_trans_store_idFrom: v,
                                        rel_trans_store_idTo: v,
                                      }));
                                      transAuto.debouncedSearchFrom(v);
                                    }}
                                    onKeyDown={transAuto.keyDownFrom}
                                    onBlur={(event) => {
                                      if (
                                        !event.relatedTarget ||
                                        !event.relatedTarget.closest(".dropdown-class")
                                      ) {
                                        handleBlurAutocomplete(event);
                                      }
                                    }}
                                    label={
                                      errorsFiltersFormDI.rel_trans_store_idFrom != null
                                        ? t(errorsFiltersFormDI.rel_trans_store_idFrom)
                                        : t("Text_Filter_Trans_From")
                                    }
                                    placeholder={t("PlaceHolder_Filter_Trans_From")}
                                    inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                    variant="outlined"
                                  />

                                  {transAuto.filteredFrom.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: "0px",
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "18px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {transAuto.filteredFrom.map((store, index) => (
                                        <MenuItem
                                          key={store.id}
                                          onClick={() => transAuto.selectFrom(store)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "18px",
                                            backgroundColor:
                                              index === transAuto.hiFrom ? "#4e73df" : "transparent",
                                            color: index === transAuto.hiFrom ? "white" : "black",
                                          }}
                                        >
                                          {store.documentid} - {store.tradename}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )}
                                </span>

                                

                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="rel_trans_store_idTo"
                                    name="rel_trans_store_idTo"
                                    value={filtersFormDI.rel_trans_store_idTo}
                                    onChange={(e) => {
                                      const v = upper(e.target.value);
                                      setFiltersFormDI((p) => ({ ...p, rel_trans_store_idTo: v }));
                                      transAuto.debouncedSearchTo(v);
                                    }}
                                    onKeyDown={transAuto.keyDownTo}
                                    onBlur={(event) => {
                                      if (
                                        !event.relatedTarget ||
                                        !event.relatedTarget.closest(".dropdown-class")
                                      ) {
                                        handleBlurAutocomplete(event);
                                      }
                                    }}
                                    label={
                                      errorsFiltersFormDI.rel_trans_store_idTo != null
                                        ? t(errorsFiltersFormDI.rel_trans_store_idTo)
                                        : t("Text_Filter_Trans_To")
                                    }
                                    placeholder={t("PlaceHolder_Filter_Trans_To")}
                                    inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                    variant="outlined"
                                  />

                                  {transAuto.filteredTo.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: "0px",
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "18px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {transAuto.filteredTo.map((store, index) => (
                                        <MenuItem
                                          key={store.id}
                                          onClick={() => transAuto.selectTo(store)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "18px",
                                            backgroundColor:
                                              index === transAuto.hiTo ? "#4e73df" : "transparent",
                                            color: index === transAuto.hiTo ? "white" : "black",
                                          }}
                                        >
                                          {store.documentid} - {store.tradename}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )}
                                </span>
                              </div>
                            )}

                            {/* VEHICLE FROM / TO */}
                            {menuPermissions.canDriverMaster && (
                              <div className="form-group">
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="vehicleFrom"
                                    name="vehicleFrom"
                                    value={filtersFormDI.vehicleFrom}
                                    onChange={(e) => {
                                      const v = upper(e.target.value);
                                      setFiltersFormDI((p) => ({
                                        ...p,
                                        vehicleFrom: v,
                                        vehicleTo: v,
                                      }));
                                      vehicleAuto.debouncedSearchFrom(v);
                                    }}
                                    onKeyDown={vehicleAuto.keyDownFrom}
                                    onBlur={(event) => {
                                      if (
                                        !event.relatedTarget ||
                                        !event.relatedTarget.closest(".dropdown-class")
                                      ) {
                                        handleBlurAutocomplete(event);
                                      }
                                    }}
                                    label={
                                      errorsFiltersFormDI.vehicleFrom != null
                                        ? t(errorsFiltersFormDI.vehicleFrom)
                                        : t("Text_Filter_LicensePlate_From")
                                    }
                                    placeholder={t("PlaceHolder_Filter_LicensePlate_From")}
                                    inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                    variant="outlined"
                                  />

                                  {vehicleAuto.filteredFrom.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: "0px",
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "18px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {vehicleAuto.filteredFrom.map((vehicle, index) => (
                                        <MenuItem
                                          key={vehicle.id}
                                          onClick={() => vehicleAuto.selectFrom(vehicle)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "18px",
                                            backgroundColor:
                                              index === vehicleAuto.hiFrom ? "#4e73df" : "transparent",
                                            color: index === vehicleAuto.hiFrom ? "white" : "black",
                                          }}
                                        >
                                          {vehicle.vehiclestore_licenseplate}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )}
                                </span>

                                

                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="vehicleTo"
                                    name="vehicleTo"
                                    value={filtersFormDI.vehicleTo}
                                    onChange={(e) => {
                                      const v = upper(e.target.value);
                                      setFiltersFormDI((p) => ({ ...p, vehicleTo: v }));
                                      vehicleAuto.debouncedSearchTo(v);
                                    }}
                                    onKeyDown={vehicleAuto.keyDownTo}
                                    onBlur={(event) => {
                                      if (
                                        !event.relatedTarget ||
                                        !event.relatedTarget.closest(".dropdown-class")
                                      ) {
                                        handleBlurAutocomplete(event);
                                      }
                                    }}
                                    label={
                                      errorsFiltersFormDI.vehicleTo != null
                                        ? t(errorsFiltersFormDI.vehicleTo)
                                        : t("Text_Filter_LicensePlate_To")
                                    }
                                    placeholder={t("PlaceHolder_Filter_LicensePlate_To")}
                                    inputProps={{ style: { width: 400, fontSize: "18px" }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                    variant="outlined"
                                  />

                                  {vehicleAuto.filteredTo.length > 0 && (
                                    <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: "0px",
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "18px",
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {vehicleAuto.filteredTo.map((vehicle, index) => (
                                        <MenuItem
                                          key={vehicle.id}
                                          onClick={() => vehicleAuto.selectTo(vehicle)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: "18px",
                                            backgroundColor:
                                              index === vehicleAuto.hiTo ? "#4e73df" : "transparent",
                                            color: index === vehicleAuto.hiTo ? "white" : "black",
                                          }}
                                        >
                                          {vehicle.vehiclestore_licenseplate}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )}
                                </span>
                              </div>
                            )}

                            <div className="form-group">
                              <TextField
                                id="acceptFROM"
                                name="acceptFROM"
                                value={filtersFormDI.acceptFROM}
                                inputProps={{ style: { width: 382, fontSize: "18px" }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: "18px", background: "#FFFFFF" } }}
                                label={
                                  errorsFiltersFormDI.acceptFROM != null
                                    ? t(errorsFiltersFormDI.acceptFROM)
                                    : t("Text_Filter_Accepted")
                                }
                                placeholder={t("PlaceHolder_Filter_Accepted")}
                                variant="outlined"
                                onBlur={handleBlurSelectAccepted}
                                onChange={handleChangeSelectAccepted}
                                select
                                SelectProps={{ native: true }}
                              >
                                <option key={0} value="" />
                                {textAccepted.map((option) => (
                                  <option key={option.id} value={option.name}>
                                    {t(option.name)}
                                  </option>
                                ))}
                              </TextField>
                            </div>

                            <div className="form-group formdi-filter-checkboxes">
                              <Checkbox
                                id="isScanned"
                                name="isScanned"
                                checked={filtersFormDI.isScanned}
                                onChange={handleChangeIsScannedFilter}
                                variant="standard"
                                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                              />
                              
                              <label htmlFor="isScanned" className="text-primary" style={{ fontSize: 18 }}>
                                {t("Text_Filter_isScanned")}
                              </label>

                              

                              <Checkbox
                                id="notIsScanned"
                                name="notIsScanned"
                                checked={filtersFormDI.notIsScanned}
                                onChange={handleChangeIsNotScannedFilter}
                                variant="standard"
                                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                              />
                              
                              <label htmlFor="notIsScanned" className="text-primary" style={{ fontSize: 18 }}>
                                {t("Text_Filter_isNotScanned")}
                              </label>
                            </div>
                          </div>

                          <hr className="sidebar-divider d-none d-md-block" />

                          <div className="formdi-pending-action-group">
                            <button
                              className="formdi-pending-action-btn formdi-pending-action-btn--primary"
                              type="button"
                              onClick={handleSubmitFilterEditFormDI}
                            >
                              {t("Button_Apply")}
                            </button>

                            <button
                              className="formdi-pending-action-btn formdi-pending-action-btn--secondary"
                              type="button"
                              onClick={handleDeleteFiltersFormDI}
                            >
                              {t("Button_Cancel_Filters")}
                            </button>
                          </div>
                        </form>
                      </Box>
                    </Container>
                  </SwipeableDrawer>
                </div>
              )}

              <DiPdfPreview blob={selectedPdfPreview} onClose={() => setSelectedPdfPreview(null)} title="PDF Formularios D.I. seleccionados" />
              <FormDIPDF rowEditFormDI={rowEditFormDI} viewPDF={viewPDF} setViewPDF={setViewPDF} />

              <FormDIPurchase
                openViewPurchase={openViewPurchase}
                setOpenViewPurchase={setOpenViewPurchase}
                rowEditFormDI={rowEditFormDI}
              />

              <FormDIShared
                openSharedRowFormDI={openSharedRowFormDI}
                setOpenSharedRowFormDI={setOpenSharedRowFormDI}
                rowEditFormDI={rowEditFormDI}
              />

              <FormDIShipping
                openViewShipping={openViewShipping}
                setOpenViewShipping={setOpenViewShipping}
                rowEditFormDI={rowEditFormDI}
              />

              {/* DELETE */}
              <Dialog
                open={openDeleteRowFormDI}
                onClose={handleCancelDeleteRowFormDI}
                PaperProps={{ className: "my-dialog-paper-danger" }}
              >
                <DialogTitle className="my-dialog-title-danger">
                  {t("Text_Delete")} {rowEditFormDI.ownformdi_id} - {rowEditFormDI.preiddoc_sheet}
                  {rowEditFormDI.sufiddoc_sheet}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText-danger">
                    {t("Text_Line1")}
                    <br />
                    {t("Text_Line2")}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDelete}
                    onChange={handleChangeDeleteRowFormDI}
                  />
                </DialogContent>
                <DialogActions className="my-dialog-actions">
                  <Button onClick={handleCancelDeleteRowFormDI} className="my-dialog-button-cancel-danger">
                    {t("Button_Cancel")}
                  </Button>
                  <Button variant="contained" onClick={handleCloseDeleteRowFormDI} className="my-dialog-button-delete">
                    {t("Button_Delete")}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* COPY */}
              <Dialog open={openCopyRowFormDI} onClose={handleCancelCopyFormDI} PaperProps={{ className: "my-dialog-paper" }}>
                <DialogTitle className="my-dialog-title">
                  {t("Text_Copy")}: {rowEditFormDI.preiddoc_sheet}
                  {rowEditFormDI.sufiddoc_sheet}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-contentText">
                    {t("Text_Line1_Copy")}
                  </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="numberCopy"
                    label={t("Text_Label_Copy")}
                    type="number"
                    inputProps={{ min: 1, step: 1 }}
                    fullWidth
                    variant="standard"
                    className="my-dialog-input"
                    defaultValue={numberCopy || 1}
                    onChange={handleChangeCopyFormDI}
                  />
                </DialogContent>
                <DialogActions className="my-dialog-actions">
                  <Button onClick={handleCancelCopyFormDI} className="my-dialog-button-cancel">
                    {t("Button_Cancel")}
                  </Button>
                  <Button variant="contained" onClick={handleCloseCopyRowFormDI} className="my-dialog-button-copy">
                    {t("Button_Copy")}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* CREATE SHIPPING */}
              <Dialog
                open={openShippingRowFormDI}
                onClose={handleCancelShippingFormDI}
                PaperProps={{ className: "my-dialog-blue-paper" }}
              >
                <DialogTitle className="my-dialog-blue-title">
                  {t("Button_Create_Shipping").toUpperCase()}
                  <div>
                    <small>
                      {rowEditFormDI.preiddoc_sheet}
                      {rowEditFormDI.sufiddoc_sheet}
                    </small>
                  </div>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText className="my-dialog-blue-contentText">{t("Text_Line9")}</DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label_Confirma")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-blue-input"
                    placeholder={CONFIRM_CODE}
                    defaultValue={idCodeReturn || ""}
                    onChange={handleChangeEnableReturnFormDI}
                  />
                </DialogContent>
                <DialogActions className="my-dialog-blue-actions">
                  <Button onClick={handleCancelShippingFormDI} className="my-dialog-blue-button-cancel">
                    {t("Button_Cancel")}
                  </Button>
                  <Button variant="contained" onClick={handleCreateShipping} className="my-dialog-blue-button-copy">
                    {t("Button_CONFiRM")}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* FINISH / RETURN */}
              <Dialog
                open={openReturnFormDI}
                onClose={handleCancelReturnFormDI}
                PaperProps={{ className: "my-dialog-blue-paper" }}
              >
                <DialogTitle className="my-dialog-blue-title">
                  {typeOfList === "1" || typeOfList === "3" ? t("Button_Finish") : t("Button_Pending")}
                </DialogTitle>
                {!isSingleFormDISelection && (
                <DialogContent>
                  <DialogContentText className="my-dialog-blue-contentText">{t("Text_Line9")}</DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label_Confirma")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-blue-input"
                    placeholder={CONFIRM_CODE}
                    defaultValue={idCodeReturn || ""}
                    onChange={handleChangeEnableReturnFormDI}
                  />
                </DialogContent>
                )}
                <DialogActions className="my-dialog-blue-actions">
                  <Button onClick={handleCancelReturnFormDI} className="my-dialog-blue-button-cancel">
                    {t("Button_Cancel")}
                  </Button>
                  <Button variant="contained" onClick={handleFinishSelectedFormDI} className="my-dialog-blue-button-copy">
                    {t("Button_CONFiRM")}
                  </Button>
                </DialogActions>
              </Dialog>

              {/* ESIR RESULT */}
              <Dialog
                open={openErrorRowFormDI}
                onClose={handleCancelErrorRowFORMDI}
                maxWidth="md"
                fullWidth
                classes={{
                  paper: rowEditFormDI.statussentesir === 3 ? "esir-dialog-paper success" : "esir-dialog-paper error",
                }}
                slots={{ backdrop: Backdrop }}
                slotProps={{ backdrop: { className: "esir-dialog-backdrop" } }}
              >
                <DialogTitle
                  className={`esir-dialog-title ${
                    rowEditFormDI.statussentesir === 3 ? "esir-dialog-title--ok" : "esir-dialog-title--error"
                  }`}
                >
                  {rowEditFormDI.statussentesir === 3 ? t("Text_Successful_Send") : t("TextResulut_Send")}
                  <small>
                    {rowEditFormDI.preiddoc_sheet}
                    {rowEditFormDI.sufiddoc_sheet}
                  </small>
                </DialogTitle>

                <div className="esir-dialog-titlebar" />

                {rowEditFormDI.statussentesir !== 3 && (
                  <DialogContent dividers className="esir-dialog-content">
                    <div className="esir-dialog-content-inner">
                      <ul className="esir-dialog-list">
                        {rowEditFormDI.reasonrefund
                          ?.split("\n")
                          .map((item, idx) => (
                            item.trim() !== "" && (
                              <li
                                key={idx}
                                className={`esir-dialog-item ${
                                  rowEditFormDI.statussentesir === 3 ? "ok" : "error"
                                }`}
                              >
                                {t(item.trim())}
                              </li>
                            )
                          ))}
                      </ul>
                    </div>
                  </DialogContent>
                )}

                <DialogActions className="esir-dialog-actions">
                  <Button
                    variant="contained"
                    disableElevation
                    onClick={handleCancelErrorRowFORMDI}
                    className={`esir-dialog-btn-close ${rowEditFormDI.statussentesir >= 3 ? "success" : ""}`}
                  >
                    {t("Button_Exit")}
                  </Button>
                </DialogActions>
              </Dialog>
            </>
          ) : (
            <LoadingNews />
          )}
        </div>
      ) : null}
    </>
  );
};

FormsDIFilter.propTypes = {
  showModalFormSettings: PropTypes.bool.isRequired,
  typeOfList: PropTypes.string.isRequired,
};

export default FormsDIFilter;
